import { getLink } from '../../../../utils/utils';

import translator from "./translator";

const content = {
	rus: (
		`
		<div style="text-align: justify;">
			<p class="mb-1">
				В один прекрасный день случилось так, что великий конструктор Трурл пришёл к своему другу Клапаузиусу молчаливый и задумчивый; 
				а когда тот попробовал его развлечь последними кибернетическими сплетнями, вдруг сказал ни с того ни с сего:
			</p>
			
			<p class="mb-1">
				- Прошу тебя, не старайся превратить моё угрюмое настроение в беззаботное; поскольку в душе моей растёт понимание столь же верное, сколь и грустное. 
				А именно, пришёл я к выводу, что за всю нашу деятельную жизнь не сделали мы ничего ценного!
			</p>
			
			<p class="mb-3">
				Говоря это, обратил он взор, полный осуждения и неудовольствия, на развешанную по стенам Клапаузиусового кабинета богатую коллекцию орденов, 
				знаков отличия и почётных дипломов в позолоченных рамках. 
			</p>
			
			<p class="mb-3">
				- На каком основании ты выносишь столь строгий приговор? – спросил, становясь серьёзным, Клапаузиус.
			</p>
			
			<p>
				- Сейчас тебе всё выскажу. 
				Мы мирили поссорившиеся царства, поставляли монархам тренажёры власти, строили машины-рассказчики и такие, что могли охотиться, 
				побеждали коварных тиранов и галактических убийц, которые готовили на нас засады; однако, таким образом только сами получали удовлетворение, 
				себя лишь возносили в собственных глазах; и в то же время ничего мы не сделали для Всеобщего Добра!
			</p>
			<p class="mb-3">
				Все наши быстро охладевавшие порывы к улучшению жизни аборигенов, попадавшихся нам в межпланетных путешествиях, 
				ни разу не привели к сотворению Абсолютного Счастья. 
				Вместо решений истинно совершенных, достигали мы только приближённых, ходульных и мнимых; так что заслужили мы имя престидигитаторов онтологии, 
				ловких софистов творения, а отнюдь не достойных Ликвидаторов Зла!
			</p>
			
			<p class="mb-3">
				- Когда я слышу, что кто-то разглагольствует о планировании Всеобщего Счастья, волосы у меня на голове дыбом встают, – воскликнул Клапаузиус. 
				– Опомнись, Трурл! Разве не известны тебе бесчисленные примеры подобно начатых дел, которые превращались потом в одни руины и могилы наилучших намерений? 
				Или ты забыл о печальной судьбе пустынника Добрицы, который захотел силой осчастливить Космос при помощи препарата, названного альтруизином? 
				Не знаешь разве, что можно в какой-то мере уменьшать жизненные неурядицы, вершить справедливость, прояснять затмения Солнца, 
				смазывать шестерёнки общественных механизмов, - но счастья ты никакими машинами не произведёшь! 
				О его повсеместном воцарении можно только тихонько мечтать в хорошую погоду, как сейчас, например; преследовать его в своём воображении, 
				упиваться сладким видением – и это всё, на что способно мудрейшее существо, друг мой!
			</p>
			
			<p class="mb-3">
				- Это ты так думаешь! – буркнул Трурл. 
				– В конце концов, может быть, осчастливить тех, кто уже давно существует, и сделать это вполне определённым, даже тривиальным способом – 
				в самом деле невыполнимая задача. 
				Однако было бы возможно создание существ, с таким умыслом сотворённых, чтобы они ничего, кроме счастья, и не ведали. 
				Представь себе, каким величественным памятником наших деяний конструкторских (которые иначе обратило бы в прах неумолимое время) 
				стала бы сияющая на небе планета, к которой остальные племена, живущие во мраке, поднимали бы глаза, полные веры, чтобы провозгласить: 
				«Да! Воистину счастье возможно в виде бесконечной гармонии, а доказал это великий Трурл, при немалом содействии друга своего Клапаузиуса; 
				доказательство же существует и цветёт пышным цветом перед нашим восхищённым взором!»
			</p>
			
			<p class="mb-3">
				- Неужели ты не догадываешься, что о проблеме, тобой затронутой, я не раз уже размышлял? – признался Клапаузиус. 
				– Но возникают тут серьёзные дилеммы. 
				Уроков, которые преподнесла история Добрицы, ты, как видно, не помнишь и поэтому хочешь осчастливить создания, которых ещё нет, 
				то есть желаешь создать счастье на пустом месте. 
				Следовательно, первым делом стоило бы рассмотреть, можно ли вообще осчастливить несуществующих? Вдумайся в это как следует! 
				Ты должен был бы прежде всего доказать, что состояние несуществования со всех точек зрения хуже состояния существования, даже не совсем приятного, 
				так как без такого доказательства фелицитологический эксперимент, идеей которого ты так поглощён, мог бы дать осечку. 
				И тогда к бесчисленным несчастливцам, от которых и так ломится Космос,ты добавил бы ещё кучку новых, тобою сотворённых – и что же дальше?
			</p>
			
			<p>
				- Конечно, эксперимент рискованный, – признался, хоть и неохотно, Трурл. 
				– Но несмотря на это, я полагаю, что стоит попробовать. 
				Ведь природа только с виду беспристрастна, производя вроде бы что попало и как выйдет, одинаково добрых и злых, нежных и свирепых, 
				- но достаточно посмотреть на уцелевших, чтобы убедиться, что выживают всегда лишь создания жестокие и злые, пожравшие нежных и добрых. 
				А когда неудачникам кажется, что всё идёт плохо, они измышляют себе смягчающие вину обстоятельства или высший закон, 
				так что мерзость бытия становится приправой, обостряющей аппетит к раю или прочим подобным местам. 
				Я считаю, что с этим пора покончить! 
			</p>
			<p class="mb-3">
				Природа в общем не зла, она только тупая как валенок, всегда идёт по линии наименьшего сопротивления. 
				А нужно её заменить и самому производить возвышенные существа, чтобы их появление стало в самом деле очищением жизни. 
				Так была бы внесена справедливость и в прошлое, полное стенаний жертв, которое не слышно на других планетах только из-за космических расстояний. 
				Ну какого дьявола всё, что живёт, должно страдать? 
				Если бы страдания каждого живого существа имели хоть такую же силу, как капля дождя, то – даю голову на отсечение – уже века назад мир бы погиб от потопа. 
				Но они страждут, пока живут, и поэтому прах, что покоится в могильных склепах и заброшенных городах, тихонько себе помалкивает, и даже ты, 
				со своим всемогуществом, не нашёл бы в нём и следа горя и забот, которые раздирали вчера сегодняшний труп. 
			</p>
			
			<p class="mb-3">
				- Да, мёртвые сраму не имут, - подтвердил Клапаузиус. 
				– Это верные слова, и означают они прекращение страданий.
			</p>
			
			<p class="mb-3">
				- Но и появление новых страдальцев! – возвысил голос Трурл. 
				– Неужели ты не понимаешь, что мой план – это преодоление заскорузлых предрассудков?!
			</p>
			
			<p class="mb-3">
				- Интересно… Каким же это способом существо счастливое (допустим, что такое возможно) будет удовлетворено прекращением своих мук, 
				когда всякие мучения продолжают существовать во всём остальном Космосе? 
				Разве сегодняшний штиль отменяет вчерашнюю бурю? 
				Разве день отрицает ночь? 
				Тебе не кажется, что ты ерунду городишь?
			</p>
			
			<p class="mb-3">
				- Так что, по-твоему, не нужно ничего делать?
			</p>
			
			<p class="mb-3">
				- Я не говорю, что ничего. 
				Ты можешь улучшать существующую жизнь, но даже и это связано с известным риском: им всё, что ни дай, всё будет мало! 
				Или ты иного мнения? 
				Думаешь, если Космос битком набить счастьем, это изменит хоть в какой-то мере то, до чего в нём уже дошло?
			</p>
			
			<p class="mb-3">
				- Изменит, именно что изменит, пойми ты наконец! – кричал Трурл. 
				– Если даже деяние моё не захватит уже минувшее, то изменит всё же то целое, частью которого оно является. 
				И после этого каждый должен будет сказать: «Тяжкие труды, тошнотворные цивилизации, кошмарные культуры – это всё лишь вступление к самому главному, 
				то есть ко времени всеобщей любви! 
				Трурл, этот великий муж, так помыслил, что дурное прошедшее нужно использовать для создания светлого будущего. 
				На бедах он учился, как творить богатство; на разочарованиях – насколько ценны наслаждения; одним словом, Космос, именно тем, что он такой мерзкий, 
				дал ему импульс к сотворению Добра! 
				Наша эпоха будет приготовительно-вдохновительной – соображаешь? – и благодаря ей наступит желанное Осуществление. 
				Ну что, убедил я тебя?
			</p>
			
			<p>
				- Под Южным Крестом - сказал Клапаузиус, - находятся владения короля Троглодита, который любит горизонты, утыканные виселицами, 
				скрывая это пристрастие за утверждением, что такими негодяями, как его подданные, нельзя править иначе. 
				Хотел он и меня для этой же цели приспособить сразу по прибытии; но сообразив, что я его могу в порошок стереть, сразу перепугался, 
				так как считал делом нормальным, что если он меня не прикончит, так я его прикончу. 
				И вот, чтобы меня иным макаром подавить, собирает он свой учёный совет, от которого я услышал доктрину власти, 
				основанную на весьма оригинальных соображениях. 
				Эти наёмные мудрецы поведали мне, что чем им хуже, тем скорее должно прийти улучшение; и значит, тот, кто творит с ними такое, 
				что и вытерпеть больше нельзя, этим самым только приближает всеобщее благоденствие. 
			</p>
			
			<p class="mb-3">
				Король был рад их речам, так как выходило, что никто не делает больше, чем он, для грядущего Добра. 
				Однако вскоре привёл он уже упомянутыми пеньковыми транквилизаторами разгулявшуюся мысль провозвестников к порядку. 
				Так твои счастливцы должны памятники Троглодиту ставить, а ты быть благодарен ему подобным – нет, скажешь? 
			</p>
			
			<p class="mb-3">
				- Гнусная и циничная притча! – выпалил задетый за живое Трурл. 
				– Я думал, что ты присоединишься ко мне, но вижу теперь, что ты только источаешь яд скептицизма и софизмами выворачиваешь наизнанку благородство моих намерений. 
				А ведь они несут избавление в космическом масштабе!
			</p>
			
			<p class="mb-3">
				- Ах, ты хочешь стать Спасителем Космоса? – протянул Клапаузиус. 
				– Трурл, друг мой, я должен приковать тебя цепями к этому креслу, чтобы ты имел время опомниться; боюсь только, что это надолго затянется. 
				Об одном лишь умоляю тебя: не осчастливливай впопыхах! 
				Не улучшай жизнь с нахрапу! 
				А если бы ты даже и сотворил когда-нибудь счастливцев (в чём я очень сомневаюсь), так ведь останутся кроме них и другие! 
				Дойдёт тогда дело до зависти, свар, озлобленья, и кто знает, не окажешься ли ты перед прекрасным выбором: или же твои счастливцы покорятся завистникам, 
				или вынуждены будут этих противных, убогих и нахальных с лица земли стереть: исключительно во имя установления всеобщей гармонии? 
			</p>
			
			<p class="mb-3">
				Трурл вскочил, но, опомнившись, разжал кулаки, ибо зуботычины не были бы самым подходящим началом для Эры Всеобщего Счастья, 
				которую он твёрдо уже решил внедрить повсеместно.
			</p>
			
			<p class="mb-5">
				- Прощай! – холодно бросил он. 
				– Агностик несчастный, маловер, пленник естественного хода вещей, буду с тобой спорить не словами, но делами! 
				По плодам трудов моих узнаешь со временем, что я был прав!
			</p>
			
			
			<p class=" text-center mb-5">* * *</p>
			
				
			<p class="mb-3">
				Вернувшись домой, Трурл погрузился в глубокое раздумье. 
				Судя по дискуссии с Клапаузиусом, у него уже имелся готовый план действий, что несколько расходилось с действительностью. 
				Честно говоря, он ни малейшего понятия не имел, с чего начать. 
				Взял он тогда с библиотечных полок груду книг, посвящённых описаниям бесчисленных цивилизаций, и накинулся на них с достойным удивления жаром. 
				А так как, несмотря на это, он всё же слишком медленно заполнял свой мозг необходимыми фактами, то притащил из погреба восемьсот кассет ртутной, 
				свинцовой, ферромагнитной и крионической памяти, подключил их все проводами к своему естеству и за несколько секунд вобрал в себя четыре триллиона битов самой лучшей и самой исчерпывающей информации, 
				какую только можно было найти среди тьмы звёзд, на планетах, а также на остывающих солнцах, которые уже заселили терпеливые летописцы. 
				Это было напряжение такое сильное, что его затрясло с головы до ног, он посинел, глаза вылезли из орбит, судорога его схватила и он задрожал, 
				словно не историософией и историографией, а молнией был поражён. 
				Потом, однако же, собрал силы, отключился, вытер лоб, опёрся ещё дрожащими коленями о стол, за которым работал, и воскликнул: 
			</p>
			
			<p class="mb-3">
				- Вижу я, что было и есть ещё хуже, чем я мог вообразить!
			</p>
			
			<p class="mb-3">
				После этого некоторое время он чинил карандаши, наливал чернила в чернильницы, укладывал стопками чистые листочки; 
				однако из этих приготовлений как-то ничего не возникало, так что уже совсем раздражённый, он сказал себе: 
			</p>
			
			<p class="mb-3">
				- Должен я из простой добросовестности познакомиться с писаниями стародавних, архаических мудрецов! Я всегда на них как-то не обращал внимания, считая, 
				что от этих старых хрычей современный конструктор ничему научиться не может. 
				Но пропадать, так с музыкой! Ладно! 
				Изучу уж и этих полупещерных, ветхозаветных умников, благо застрахую себя этим от каверзных выпадов Клапаузиуса, который их, правда, 
				тоже никогда не читал (а кто их вообще читает?), однако украдкой выписывает себе из их книг по фразе, чтобы меня цитатами позорить и обвинять в невежестве.
			</p>
			
			<p class="mb-3">
				Затем в самом деле взялся он за истлевшие, заплесневелые книги, хотя ужасно ему этого не хотелось. 
				В середине ночи, окружённый книгами, валявшимися раскрытыми вокруг, ибо он сбрасывал их нетерпеливо со стола, Трурл подумал:
			</p>
			
			<p class="mb-3">
				- Вижу я, что мне придётся исправлять не только структуру общества разумных существ, но и то, что они напридумывали как философию. 
				Колыбелью жизни был всё-таки океан. 
				У берегов он загрязнялся, получилось жидкое болото, всякие там коллоиды-фигоиды; Солнце пригрело, болото загустело, ударила в него молния, 
				всё заквасила на аминах – или на аминь – и так получился комок протоплазмы, который со временем вышел на сушу. 
				Выросли у него уши, чтобы слышал, где найти добычу, а также ноги и зубы, чтобы догнал её и съел. 
				А если они у него не выросли или покороче были, то его съедали. 
				Создательница разума есть тогда Эволюция; и что же в ней Глупость и Мудрость, как и Добро и Зло? Добро – это тогда, когда я кого-нибудь съем, 
				а Зло – когда меня съедят. 
				То же и с Разумом: съеденный, если уж на то пошло, глупее съевшего – ведь не может же быть правым тот, кого нет, а вообще нет того, кто уже употреблён в пищу. 
				Однако тот, кто съел бы всех остальных, сам умер бы с голоду; и так установилось равновесие. 
				С течением времени комочки обызвествились; но это весьма хрупкий материал; и в поисках лучшего эти мягкие существа открыли металлы. 
				Они повторили сами себя в железе, в роботах; но исходить из готового – самый лёгкий и простой путь, поэтому до истинного совершенства у них не дошло. 
				Ба! А вот если бы всё было наоборот: сначала появился металл, потом из него более мягкое вещество, и под конец – нежнейшая субстанция, 
				то и философия выглядела бы совершенно иначе: как видим, выводится она прямо из материала! 
				Но все выжившие существа упорно воображали, что там лучше, где их нет. 
				Если они обитали в воде – думали, что на земле рай; если на земле – что на небе; если имели крылья, воображали, свой идеал с ластами; 
				если ноги – пририсовывали себе крылышки и вопили: «Ангел!». 
				Странно, что раньше я этого не замечал. 
				Итак, правило это мы назовём Вселенским Законом Трурла: вследствие несовершенства собственного строения, каждая душа избирает себе Идеальный Образец, Высший Абсолют. 
				Я должен буду себе это хорошенько зарубить на носу, когда возьмусь за исправление основ философии. 
			</p>
			
			<p class="mb-3">
				Сейчас, однако, уже время не рассуждать, а строить. 
				Прежде всего, создам Добро… Но что же это такое? Несомненно, его нет там, где никого нет. 
				Водопад ни добр, ни зол для скалы, как и земная впадина для озера. 
				Смонтирую тогда Кого-Нибудь. 
				Но вот самое главное: будет ли ему хорошо? А откуда вообще известно, что кому-то хорошо? Допустим, я бы увидел, что Клапаузиусу приходится плохо. 
				И что же? Половиной души сожалел бы, половиной радовался, разве не так? Как-то сложно выходит… Может быть, кому-то хорошо по сравнению с соседом; 
				но он об этом не знает и поэтому не думает, что ему хорошо. 
				Возможно, стоило бы создавать существа, на глазах у которых им подобные корчились бы в муках? 
				Чтобы тем сильнее они удовлетворялись в силу контраста? 
				Можно бы, но как-то уж слишком это гадко. 
				И вообще, не стоит сразу браться за счастливые сообщества; создадим-ка сначала индивидуума!
			</p>
			
			<p class="mb-3">
				Тут он засучил рукава и за три дня соорудил Счастливого Созерцателя Жизни – машину, которая своим электронным сознанием соединялась со всеми вещами, 
				которые видела, и не было на свете ничего такого, что бы не доставило ей удовольствия. 
				Сел перед нею Трурл, чтобы подумать, то́ ли это, что он имел в виду. 
				Созерцатель, раскоряченный на трёх железных ногах, водил выпученными глазками вокруг, и если попадал взглядом на доски забора, на камушек или старый башмак, 
				то заходился от восторга, аж постанывал тихонько от переполнявшей его любви. 
				Когда же зашло Солнце и небо на закате порозовело, то он даже присел на корточки от восхищения. 
			</p>
			
			<p class="mb-3">
				- Клапаузиус скажет, конечно, что сами приседания и стоны ещё ни о чём не говорят, - сказал себе Трурл, всё более почему-то неспокойный. 
				– Захочет он доказательств…
			</p>
			
			<p class="mb-3">
				И вставил тогда Трурл в брюхо Созерцателю здоровенные часы с позолоченной стрелкой, а циферблат у них разметил в единицах счастья, названных им гедонами, 
				или, сокращённо, гедами. 
				За один гед принял он то количество наслаждения, которое ощущаешь, когда пробежишь четыре мили с гвоздём в ботинке, а потом этот гвоздь вдруг исчезнет. 
				Умножил путь на время, разделил на остроту гвоздя, вынес за скобки коэффициент сопротивляемости пятки, 
				и удалось ему таким образом перевести счастье в систему CGS (сантиметр-грамм-секунда). 
				Это доставило ему немалое удовольствие.
			</p>
			
			<p class="mb-3">
				А тем временем Созерцатель, вглядываясь в запачканный маслом рабочий фартук Трурла, возившегося перед ним, принимал, 
				в зависимости от угла наклона и общей освещённости, от 11,8 до 18,9 гедов в секунду. 
				Здесь конструктор совсем успокоился. 
				Высчитал тут же, что один килогед – это столько, сколько старцы получили, подглядывая за купающейся Сусанной; один мегагед – это радость смертника, 
				вовремя вынутого из петли, и т.д. 
				Видя, что так легко можно всё вычислить, послал Трурл самого быстроногого робота за Клапаузиусом, и когда тот прибыл, сказал ему:
			</p>
			
			<p class="mb-3">
				- Смотри и учись!
			</p>
			
			<p class="mb-3">
				Клапаузиус обошёл машину кругом; она же, направив на него множество телеобъективов, присела пару раз и застонала. 
				Эти леденящие кровь звуки вроде бы удивили конструктора, но он не подал виду и лишь спросил:
			</p>
			
			<p class="mb-3">
				- Что это?
			</p>
			
			<p class="mb-3">
				- Существо счастливое – ответил Трурл, - а именно Счастливый Созерцатель Жизни, сокращённо Счасожив. 
			</p>
			
			<p class="mb-3">
				- И что же делает этот Счасожив? 
			</p>
			
			<p class="mb-3">
				Трурл почувствовал в этих словах иронию, однако пропустил её мимо ушей. 
			</p>
			
			<p class="mb-3">
				- Без устали активно наблюдает! – пояснил. 
				– И не просто наблюдает, отмечает, а делает это интенсивно, сосредоточенно, прилежно; и всё, что наблюдает, одаряет невыразимой любовью! 
				И любовь эта, переполняя его аноды и обводы, даёт ему неземное блаженство, выражением чего служат те звуки, которые ты слышишь, 
				когда он вглядывается в твоё, по-моему, весьма заурядное лицо.
			</p>
			
			<p class="mb-3">
				- Значит ли это, что машина получает активное удовольстие от существования в виде созерцания? 
			</p>
			
			<p class="mb-3">
				- Именно так! – сказал Трурл, но тихо, потому что не был уже отчего-то так уверен в себе, как минуту назад. 
			</p>
			
			<p class="mb-3">
				- А это, наверное, фелицитометр, градуированный в единицах радости существования? – Клапаузиус указал пальцем на позолоченную стрелку.
			</p>
			
			<p class="mb-3">
				- Да…
			</p>
			
			<p class="mb-3">
				Разные вещи начал тогда показывать Клапаузиус Счасоживу, внимательно наблюдая при этом за отклонениями стрелки. 
				Трурл, успокоенный, ввёл его тем временем в теорию гедонов, или теоретическую фелицитометрию. 
				От слова к слову, от вопроса к вопросу текла та беседа, как вдруг Клапаузиус спросил:
			</p>
			
			<p class="mb-3">
				- А интересно, сколько бы единиц содержалось в сознании того, кого триста часов били, оттого, что он сам, в свою очередь, тем, кто его бил, жару задаст? 
			</p>
			
			<p class="mb-3">
				- А, это простое задание – обрадовался Трурл, и начал было высчитывать, но громкий смех друга остановил его. 
				Трурл, оторопев, не мог понять в чём дело, пока Клапаузиус не сказал ему, всё ещё смеясь:
			</p>
			
			<p class="mb-3">
				- Значит, ты считаешь, что началом всего положил Добро, а, Трурл? Ну что же, начало тебе удалось. 
				Давай и дальше так! Вот увидишь, как всё пойдёт хорошо. 
				А сейчас до свиданья.
			</p>
			
			<p class="mb-3">
				И ушёл, оставив Трурла в полной растерянности. 
			</p>
			
			<p class="mb-3">
				- Ну и получил! Ну и подкузьмил же он меня! – восклицал конструктор, и вопли его сливались с экстатическими стенаниями Счасожива, 
				которые так разозлили мастера, что впихнул он бедную машину в кладовку, забросал её железяками и замкнул дверь на засов. 
				Потом он сел к пустому столу и задумался:
			</p>
			
			<p class="mb-3">
				- Спутать эстетическое наслаждение с Добром – вот же я осёл! 
				Да в конце концов, разве Счасожив разумен? 
				Нет, нужно делать всё совсем по-другому, вплоть до атомных ядер! 
				Счастье – конечно, любовь – без сомнения, но не за чужой счёт! Не из Зла исходящее! А, вот оно! 
				Так что же такое Зло? Ох, вижу, что в моей прежней конструкторской деятельности столького я не учёл! 
			</p>
			
			<p class="mb-3">
				Восемь дней он не ложился, не спал, не ел, только изучал тысячи книг учёных, материи Добра и Зла разбирающих. 
				И решил он, что большинство мудрецов считает важнейшими вещами общественное попечение и всеобщую доброжелательность. 
				И то и другое должны оказывать друг другу разумные существа; без этого и жить нельзя. 
				Правда, как раз под этим лозунгом людей на кол сажали, расплавленным свинцом поили, а также четвертовали, колесовали, на дыбе ломали; 
				в важнейшие же исторические моменты использовали даже колесницы о шести конях. 
				И в бесчисленном множестве других пыток доброжелательность была оказана с позиции вечности, когда её адресовали к духу, не к телу. 
			</p>
			
			<p>
				- Нет, не могу! – сказал себе Трурл. 
				– Ну, допустим, что совесть помещается не в её владельце, а вовне, в ближнем его, и наоборот. 
				И что бы получилось? Ой, беда! Ведь тогда мои плохие поступки грызли бы соседа моего, и я тем легче погрязал бы в грехе! 
				Или, может, встроить в обычную совесть усилитель угрызений, чтобы каждый дурной поступок влёк за собой последствия в тысячи раз более тяжёлые? 
				Но тогда каждый из простого любопытства – взаправду ли новая совесть так дьявольски мучит – 
				сделает что-нибудь плохое и до конца дней своих будет терзаться муками ада! 
				А если сделать совесть обратимой, но только чтобы сам хозяин мог её очищать? Нет, не выйдет, для чего же тогда отмычки? 
			</p>
			
			<p>
				А если наладить передачу – один чувствует за всех и все за одного? Но ведь это уже было, именно так действовал альтруизин… 
				Или так: у каждого в тело вмонтирован детонатор с приёмником; и если ему за его злые и подлые поступки десять человек зла желают, то их желание, 
				от суммирования десятка воль, принимается его гетеродином, и человек взлетает в воздух. 
				Ну, как? Разве не избегал бы тогда каждый Зла, как заразы? Конечно, избегал бы, да ещё как! 
				Но… Что это была бы за жизнь, с миной замедленного действия возле желудка? 
				В конце концов, могли бы существовать тайные списки неугодных, десять негодяев объединились – и вот невинного разорвало на мелкие кусочки… 
				Может, просто их маркировать? Тоже не то… Чёрт подери, да как же это я, который галактики, как шкафы, двигал, 
				не могу решить такой вроде бы простой на вид задачи?!
			</p>
			
			<p class="mb-3">
				Допустим, что каждый член данного сообщества здоров, румян и весел, с утра до ночи скачет, смеётся и поёт, делает другим добро без отдыху и сроку, 
				и другие ему так же; а если спросить, то каждый тебя уверит, что чрезвычайно доволен собственным и всех прочих существованием… 
				Разве не было бы такое общество абсолютно счастливым? 
				Ведь там никто никому Зла содеять не может! А почему не может? Потому что не хочет. 
				А почему не хочет? Потому что ничего с этого иметь не будет. 
				Вот и ответ! Вот и есть у меня уже великолепный в своей простоте план массового производства! 
				Заранее вижу: изо всех счастье так и прёт! И что же тогда скажет этот циник-мизантроп, этот агностик скептический, Клапаузиус, 
				куда он вставит свои пять копеек, это своё закоснелое недоверие и насмешку? 
				Пусть себе вынюхивает, пусть ищет изъяны в целом; а тем временем каждый будет делать другому всё лучше и лучше, так что дальше уж некуда… 
				Хмм… А не плохо ли им придётся, не измучатся ли они, не попа́дают ли под градом, под лавиной столь добрых поступков? 
				Ну, сделают себе какие-нибудь там редукторы, дроссели, счастьеупорные стены, комбинезоны, экраны, изоляторы… 
				Сейчас, сейчас, только не спешить, снова бы чего-нибудь не проворонить… Значит: первое – весёлые, второе – доброжелательные, третье – скачут, 
				четвёртое – румяные, пятое – чудесно им, шестое – покладистые… - ладно, можно начинать!
			</p>
			
			<p class="mb-3">
				До обеда он поспал немножко, ибо ужасно утомили его все эти раздумья. 
				Потом быстренько встал, резво набросал планы, бодро так, с подъёмом составил программу для машины, 
				рассчитал алгоритмы и для начала создал счастливое сообщество из девятисот персон. 
				Для того же, чтобы царило в нём равенство, сделал всех удивительно похожими друг на друга. 
				А дабы о еде-питье заботясь, друг друга они не побили, дал им источник энергии от холодного атомного огонька; 
				были они, следовательно, вечными трезвенниками, от еды и питья воздерживаясь. 
				Потом сел Трурл на завалинку и до захода солнца наблюдал, как они скачут, шумно выражая свою радость, как себе добро учиняют, 
				гладя друг друга по головкам, камни убирают один другому с дороги; как, крепкие, бодрые, весёлые, проводят жизнь в беззаботных утехах. 
				Стоило кому-нибудь ногу вывихнуть, аж черно вокруг становилось от толпы: и не из простого любопытства, а исключительно из сочувствия и желания помочь. 
				Правда, от избытка чувств сначала ногу совсем отрывали, вместо того, чтобы вправить; но Трурл подрегулировал им редукторы, добавил сопротивлений, 
				и с честью мог он уже принимать Клапаузиуса. 
				Тот посмотрел на радостное ликование, с довольно угрюмым видом выслушал крики восторга и внезапно спросил:
			</p>
			
			<p class="mb-3">
				- А могут они грустить?
			</p>
			
			<p class="mb-3">
				- Что за глупый вопрос? Конечно нет. 
				- ответил Трурл.
			</p>
			
			<p class="mb-3">
				- Значит, всегда будут так скакать, резвиться, добро делать и вопить, что им чудесно?
			</p>
			
			<p class="mb-3">
				- Ну да! 
			</p>
			
			<p class="mb-3">
				И так как и на этот раз Клапаузиус не произнёс ни слова похвалы, Трурл добавил гневно:
			</p>
			
			<p class="mb-3">
				- Возможно, на вид это однообразно и менее живописно, чем сцены войны, но моя задача была осчастливить народ, 
				а не порадовать кого-нибудь драматическим зрелищем.
			</p>
			
			<p class="mb-3">
				- Если они делают то, что делают, лишь потому что должны, - ответил Клапаузиус – то добра в них, милый Трурл, столько же, сколько в трамвае, 
				который потому тебя не переедет, что ты стоишь на тротуаре, а он с рельс сойти не может. 
				Не тот, запомни, познаёт счастье, творя добро, кто должен других без устали по головке гладить да камни им с дороги убирать, а тот, 
				кто может также предавать, лгать, головы камнем разбивать – и не делает этого лишь по доброй своей воле! 
				А эти твои невольники – только посмешище, издевательство над высоким идеалом, который тебе удалось попрать!
			</p>
			
			<p class="mb-3">
				- Как, что ты говоришь? Они ведь всё же разумные существа… - пробормотал ошеломлённо Трурл.
			</p>
			
			<p class="mb-3">
				- В самом деле? А вот мы сейчас это проверим! 
			</p>
			
			<p class="mb-3">
				И тут же Клапаузиус дал сильного щелчка первому попавшемуся из Трурловых питомцев, спросив при этом:
			</p>
			
			<p class="mb-3">
				- Счастлив ли ты?
			</p>
			
			<p class="mb-3">
				- Безумно! – ответил тот, держась за голову, на которой уже вскочила шишка.
			</p>
			
			<p class="mb-3">
				- А сейчас? – продолжал Клапаузиус и так ему наддал, что тот только пятками в воздухе сверкнул. 
				Ещё не встал, ещё песок изо рта выплёвывал, а уже кричал:
			</p>
			
			<p class="mb-3">
				- Счастлив, ваша милость! Прекрасно я себя чувствую!
			</p>
			
			<p class="mb-3">
				- Вот видишь? – бросил Клапаузиус совершенно сбитому с толку Трурлу и ушёл. 
			</p>
			
			<p class="mb-3">
				Конструктор, невыразимо опечаленный, собрал своих добрых чад в лаборатории и там по одному разобрал их до последнего винтика, 
				причём никто из них тому не сопротивлялся; наоборот, помогали ему как могли: там придержать ключ, там вынуть гайку, 
				а некоторые так даже молотком по голове себя били, если крышка у них была плотно приделана и не хотела сама открываться. 
				Потом сложил он их части обратно в шкафы и ящики, содрал с кульмана чертежи, порвал их на мелкие кусочки, сел за стол, 
				на котором горой были свалены книги по философско-этическим проблемам, схватился за голову и простонал:
			</p>
			
			<p class="mb-3">
				- Хорошенькая история! Ну и опозорил меня этот мерзавец, этот выжига, мой друг так называемый!
			</p>
			
			<p class="mb-3">
				Трурл вынул из-под стола модель пермутатора, установки, 
				которая переводила каждое полученное ощущение в область общественного попечения и всеобщей доброжелательности, 
				положил её на камень и разбил мощными ударами в куски. 
				Но не стало ему от этого лучше. 
				Подумал он, повздыхал и взялся за воплощение новой идеи.
			</p>
			
			<p class="mb-3">
				На этот раз вышло из его рук сообщество немалое – три тысячи голов – и сразу они выбрали себе правительство тайным и равным голосованием, 
				после чего занялись разнообразными вещами: постройкой городов и плотин, открыванием законов Природы, а то и просто играли и забавлялись. 
				У каждого из них в голове был гомеостат, а в этом гомеостате две здоровенные клеммы, между которыми его вольная воля могла гулять как ей заблагорассудится. 
				Внизу находилась пружина Добра, которая тянула к себе гораздо сильнее, чем другая, меньшая, для разрушения и хаоса предназначенная. 
				Кроме того, имел каждый житель очень чувствительный орган совести, представлявший собою зубастые челюсти, начинавшие его грызть, 
				как только он сходил с прямой дорожки. 
				Однажды Трурл попробовал это устройство на специальном образце: когда дело доходило до угрызений совести, 
				беднягу трясло как в лихорадке или даже как в танце святого Витта; когда же он раскается, 
				то от чистосердечного раскаяния его начинал действовать конденсатор, который, прекращая угрызения, разводил зубья и смазывал орган совести елеем. 
				Искусно всё было придумано, слов нет! Хотел ещё Трурл соединить угрызения совести с зубной болью, но после раздумал, вспомнив, 
				что Клапаузиус опять будет кричать о принуждении и подавлении свободной воли. 
				Но сейчас это уже было бы совершенным поклёпом, потому что новые существа имели статистические приставки, и никто, даже сам Трурл, 
				не мог бы заранее сказать, что и как они будут делать. 
			</p>
			
			<p class="mb-3">
				Целую ночь будили Трурла радостные крики, и доставляло это ему немалое удовольствие.
			</p>
			
			<p class="mb-3">
				- Ну, - подумал он – теперь уж Клапаузиус ни к чему не прицепится. 
				Они счастливы, но не по программе, не по принуждению, а единственно в силу стохастичности, эргодинамичности и пробабилистичности. 
				Всё отлично! – и с этой мыслью он сладко заснул и спал до утра.
			</p>
			
			<p class="mb-3">
				Не застав сначала Клапаузиуса дома, Трурл подождал его до обеда, а затем повёл к себе, прямо на фелицитологический полигон. 
				Клапаузиус осмотрел дома, плотины, рекламы, ратушу, побеседовал с одним из её членов, с жителями города, 
				а в боковой улочке попробовал опять дать в лоб одному из прохожих; но тут же трое других схватили его за руки, 
				за ноги и с песней вынесли за пределы города; а там, раскачав, бросили в придорожную канаву. 
				И хотя они следили, чтобы не сломать ему при этом шею, всё же он был не совсем доволен, когда, покряхтывая, выбирался наверх. 
			</p>
			
			<p class="mb-3">
				- Ну? – спросил Трурл, делая вид, что вовсе не заметил посрамления друга. 
				– Что скажешь? 
			</p>
			
			<p class="mb-3">
				- Придёт утро – ответил тот. 
			</p>
			
			<p class="mb-3">
				Понимая, что он уклоняется от прямого ответа, Трурл снисходительно усмехнулся. 
			</p>
			
			<p class="mb-3">
				На следующий день, часов около двенадцати, конструкторы снова вошли в город. 
				Произошли там большие изменения. 
				Сразу же задержал их гражданский патруль, и их старший сказал Трурлу:
			</p>
			
			<p class="mb-3">
				- Что ты, сударь, так косо смотришь? Пения птиц не слышишь? Цветов не видишь? А ну, выше голову!
			</p>
			
			<p class="mb-3">
				А другой, пониже рангом, добавил:
			</p>
			
			<p class="mb-3">
				- И чтобы бодро мне, весело держаться!
			</p>
			
			<p class="mb-3">
				Третий уже ничего не сказал, только бронированным кулаком двинул конструктора под дых, аж хрустнуло; после этого все трое повернулись к Клапаузиусу, 
				но тот, не дожидаясь, так уж расстарался, такую радость проявил, что они оставили его в покое и удалились. 
				Сцена эта произвела сильное впечатление на опрометчивого творца нового строя. 
				Сейчас он, выпучив глаза, смотрел на площадь перед Дворцом Фелиции, где уже одетые в единую форму граждане, построившись в каре, 
				издавали по команде крики восторга. 
				Не успел оглянуться Трурл, как был уже схвачен и водворён в шеренгу, где они вместе с Клапаузиусом до ночи занимались строевой подготовкой, 
				состоявшей в том, чтобы по команде «раз-два-три!» себе неудобства, зато соседу в строю Добро причинять; сержанты же, называемые Фелициантами, 
				или Стражниками Всеобщего Счастья (в народе прозвали их Страсчастниками), бдительно следили, 
				чтобы все вместе и каждый в отдельности выказывали глубокое удовлетворение и чувство нерушимой законной радости. 
				Но на практике это оказалось чересчур обременительным и, улучив момент во время короткого перерыва, Трурл и Клапаузиус сбежали из строя, 
				притаились сначала за забором, а затем, припадая к земле, как под артиллерийским огнём, 
				ползком добрались до Трурлова дома и на всякий случай забаррикадировались на чердаке. 
				И вовремя это сделали, потому что уже по всему городу рыскали патрули, проверяя дома в поисках несчастливых, огорчённых, грустных; 
				и каждого найденного тут же принимались излечивать бегом и прочей муштрой. 
				Трурл, чертыхаясь, обдумывал на чердаке способы ликвидации последствий эксперимента, принявшего столь неожиданный оборот; Клапаузиус посмеивался в кулак. 
				Не придумав ничего лучше, Трурл спустился вниз и с тяжким сердцем включил демонтажёры, причём, 
				для бо́льшей уверенности и в величайшем секрете от Клапаузиуса, запрограммировал их так, чтобы они не могли попасться на удочку красивых лозунгов, 
				провозглашавших всеобщую доброжелательность и глубочайшую заботу общества обо всех его членах. 
				И как пошли там граждане драться со Страсчастниками, только искры полетели! Обороняя всеобщее счастье, Фелиция сражалась, как стадо львов, 
				оборона превратилась в настоящий бой, в войну. 
				Обе стороны проявили огромное воодушевление, разя друг друга картечью и шрапнелью, 
				так что Трурл был вынужден послать туда обозы с запчастями для своих воинов. 
				Когда они с Клапаузиусом вышли вечером во двор, поле битвы представляло собою печальное зрелище. 
				В задымленном, горящем городе то тут, то там какой-нибудь в спешке не до конца разобранный фелициант в механической агонии выражал слабым голосом 
				свою бесконечную и непоколебимую приверженность делу Всеобщего Добра. 
			</p>
			
			<p class="mb-3">
				Не думая уже о самолюбии, Трурл погрузился в отчаяние и гнев, ибо он не мог себе представить, где же на этот раз он совершил ошибку, 
				которая доброжелателей в держиморд превратила. 
			</p>
			
			<p class="mb-3">
				- Директива Вседоброжелания, мой милый, если она слишком уж обобщенно изложена, может разнообразные плоды приносить – пояснил ему Клапаузиус. 
				– Тот, кому хорошо, хочет, чтобы и другим скорее хорошо стало; а строптивых он из-под палки к счастью погонит.
			</p>
			
			<p class="mb-3">
				- И, значит, Добро может родить Зло! О, как коварна Природа Вещей! – воскликнул Трурл. 
				– Ну что же, дам тогда бой самой Природе! Подожди, Клапаузиус! Ты видишь меня временно побеждённым, - но одно поражение ещё войны не решает! 
			</p>
			
			<p class="mb-3">
				В одиночестве засел он ещё пуще прежнего за книги да конспекты, мрачный, но тем более упорный. 
				Рассудок ему подсказывал, что неплохо было бы перед следующим испытанием обвести дом стенами, а в амбразуры выставить жерла пушек; 
				но так как не мог он этого сделать по вполне понятным причинам, то решил отныне создавать только уменьшенные модели в масштабе 1:100 000, 
				проводя исследования в рамках микроминиатюристической социальной психологии. 
				Для лучшей памяти, чтобы всегда их иметь перед глазами, развесил он на стенах мастерской красиво написанные лозунги, как то: 
			</p>
			
			<p class="mb-3">
				«НЕОБХОДИМОСТЬ: <br/>
				1. ПОЛНОЙ ДОБРОВОЛЬНОСТИ <br/>
				2. МЯГКОГО УБЕЖДЕНИЯ <br/>
				3. НЕНАВЯЗЧИВОЙ ДОБРОЖЕЛАТЕЛЬНОСТИ <br/>
				4. ДЕЛИКАТНОЙ ЗАБОТЛИВОСТИ»
			</p>
			
			<p>
				и взялся за претворение этих лозунгов в жизнь. 
				Для начала он собрал под микроскопом тысячи электрочеловечков, снабдив их маленьким умишком и ненамного бо́льшей любовью к Добру, 
				так как боялся он уже в этой области фанатизма. 
				Они стали лениво кружиться по шкатулочке, отданной им на поселение, напоминая этим мерным и монотонным кружением ход часового механизма. 
				Подбавил им немного мудрости, подкрутив винтики мышления, и сразу они задвигались живее и, сделав себе из опилок инструментики, начали возводить жилища. 
				Увеличил потенциал Добра – и тотчас же общество стало самоотверженным и готовым на любые жертвы: каждый там бежал сломя голову, 
				дабы улучшить кому-нибудь жизнь; особым же спросом пользовались вдовы и сироты. 
				Таким их вниманием окружали, так уж о них заботились, так пеклись, что многие, не выдержав такого попечения, бежали за границы коробки; 
				и тогда настала настоящая неразбериха. 
				Недобор бедных и сирот породил духовный кризис: не находя в сей юдоли, то есть в шкатулке, объектов, заслуживающих такого исключительного внимания, 
				микронародец через восемнадцать поколений создал себе веру в Абсолютную Сироту, которую нельзя уже ни осиротить больше, ни осчастливить; 
				и этот абсолют проистекает из преизбытка попечения, преломленного метафизически. 
				Обратив свой взор к небу, общество и его обильно заселило: среди существ бесплотных появились Чудо-Вдова и Небесный Хозяин, 
				тоже заслуживающие исключительного внимания; тем самым мир дольний был забыт и пренебрежён, и духовные организации поглотили большинство светских. 
			</p>
			
			<p class="mb-3">
				Не так это себе представлял Трурл. 
				Добавил он трезвости, рационализма и скептицизма, пока всё не успокоилось. 
				Ненадолго, однако. 
				Появился какой-то электро-вольтер, который учил, что никакой Абсолютной Сироты нет, а есть только Космос, сотворённый силами Природы; 
				сиротные абсолютисты предали его анафеме, а потом Трурлу надо было выйти по делам. 
				Когда он вернулся часа через два, шкатулка скакала по всему столу: в ней началась религиозная война. 
				Трурл успокаивал её альтруизмом, но только зашипело; снова добавил несколько капель разума – остыло, но стали вскоре появляться из всеобщего хаоса колонны, 
				марширующие неприятно регулярным шагом. 
				Время в шкатулке текло быстро: от абсолютистов и электровольтерианцев не осталось и следа. 
				Все разглагольствовали на темы Всеобщего Добра, писали о нём книги, уже абсолютно светские; 
				но возник теперь другой вопрос – вопрос происхождения самого микрочеловечества. 
				Одни считали, что произошли из пыли на дне латунной коробки; другие же полагали, что жизнь была занесена в их вселенную извне. 
				Для решения этого острого вопроса был построен Большой Бур, чтобы Вселенную, то есть шкатулку, насквозь просверлить и исследовать, что же у неё снаружи. 
				А так как там могли быть неизвестные силы, приступили все дружно к отливанию пушек. 
				Трурл так был этим огорчён и обеспокоен, что быстро всё разобрал и воскликнул, чуть не плача:
			</p>
			
			<p class="mb-3">
				- Разум приводит в бездушию, а Добро – к безумию! Как же так, откуда такая безысходность? 
			</p>
			
			<p class="mb-3">
				И решил он это дело исследовать особо. 
				Вытащил из кладовки свой первый образец, Созерцателя, и когда тот начал постанывать перед кучей мусора, 
				подключил к нему небольшую приставку умственных способностей. 
				Сосчажив перестал стонать. 
				Спросил Трурл, что́ ему не нравится, а он на то:
			</p>
			
			<p class="mb-3">
				- Нравиться-то мне всё нравится, однако размышления сдерживают моё восхищение, потому что я хочу сначала узнать, почему же, собственно, мне это нравится, 
				а также зачем и для какой цели? 
				И вообще, кто ты такой, что отвлекаешь меня от созерцания и размышлений своими вопросами? 
				Какое отношение имеет твоё существование ко мне? 
				Что-то говорит мне, что я должен и о тебе размышлять, но рассудок велит противиться этому внутреннему голосу, ибо может это быть ловушка, 
				расставленная для меня.
			</p>
			
			<p class="mb-3">
				- Что касается наших существований – опрометчиво ответил Трурл, - то я тебя создал и, чтобы твой дух был счастлив, 
				установил абсолютную гармонию между тобой и миром. 
			</p>
			
			<p class="mb-3">
				- Гармонию? – спросил Сосчажив, нацелившись на него своими объективами. 
				– Гармонию, сударь мой? 
				А почему у меня три ноги? 
				Почему голова расположена сверху? 
				Почему я облицован слева медными пластинами, а справа железными? 
				Для чего у меня пять глаз? 
				Ответь – если в самом деле правда, что ты меня сделал из ничего: ответь, сударь мой!
			</p>
			
			<p class="mb-3">
				- Три ноги потому, что на двух стоять неудобно, а четыре – лишняя трата материала – пояснил Трурл. 
				– Пять глаз, потому что тогда у меня под рукой были хорошие линзы, а что касается пластинок, то как раз тогда у меня кончился стальной лист, 
				и пришлось взять медный.
			</p>
			
			<p class="mb-3">
				- Ещё чего! – фыркнул презрительно Сосчажив – Ты хочешь меня убедить, что всё это дело простого случая, везения, чистой случайности? 
				И я должен в такую лажу поверить? 
			</p>
			
			<p class="mb-3">
				- Я, наверное, лучше знаю, как было, если уж я тебя построил. 
				– возразил Трурл, весьма раздражённый такой наглой самоуверенностью.
			</p>
			
			<p class="mb-3">
				- Я вижу тут две возможности – ответило смышлённое создание. 
				– Первая - что ты врёшь, как сивый мерин. 
				Отложим её пока про запас. 
				Вторая – что ты, в своём ослеплении, правду глаголишь, - но отсюда ничего существенного не вытекает, потому что правда эта, 
				ввиду твоего малого знания и в сравнении с большой правдой, есть ложь. 
			</p>
			
			<p class="mb-3">
				- И каким же это образом? 
			</p>
			
			<p class="mb-3">
				- А таким, что то, что тебе кажется случайным совпадением обстоятельств, в самом деле быть им не может. 
				Нехватка стального листа, возможно, и имела место, но откуда ты знаешь, что не установила её Высшая Необходимость? 
				Наличие медной пластины показалось тебе только удобным, но и здесь наверняка вмешалась Предвечная Гармония. 
				Также и в количестве моих глаз и ног должны крыться глубочайшие Тайны Высшего Порядка, а именно Высшее Значение этих количеств, соотношений и пропорций. 
				Итак, 3 и 5 – это первые числа. 
				И могло бы одно из них делиться на другое – понимаешь? 3х5 будет 15, что означает единица и пятёрка; сложенные, они дают 6; 
				а 6 делённое на 3 будет 2, или число моих цветов, так как я с одной стороны железный, а с другой медный. 
				Разве могли бы такие точные соотношения возникнуть случайно? Смешно! 
				Я – творение, выходящее за пределы твоего узкого кругозора, ты, примитивный слесарь! 
				Если вообще есть хоть сколько-то правды в том, что ты меня построил (в чём я сильно сомневаюсь), 
				- то был ты в таком случае простым орудием Высших Законов, а я – их достойной целью. 
				Ты – случайная капля дождя, а я – цветок, венец природы, воплощающий её высшее творение; ты – кривая доска в заборе, отбрасывающая кривую тень, 
				а я – солнечный свет, который приказывает доске отделить мрак от света; ты – слепое орудие в Руке Всевышней, которая призвала меня к существованию! 
				И напрасно ты стараешься унизить моё естество, объясняя, что моя пятиглазность, 
				трехногость и двуцветность – лишь следствие причин снабженческо-экономическо-материальных! 
				Я вижу в этих отношениях отражение высших связей Существования как Симметрии; связей, значение которых я ещё до конца не постиг, но обязательно разберусь, 
				когда займусь этой проблемой в свободное время; а что касается тебя, то не собираюсь с тобой больше разговаривать, мне на тебя времени жалко.
			</p>
			
			<p class="mb-3">
				Разгневанный этой речью Трурл заволок брыкавшееся создание обратно в кладовку и, хотя оно во весь голос напоминало ему о праве на самоопределение, 
				о независимости свободной индивидуальности и о неприкосновенности личности, выключил у него усилитель умственных способностей и пошёл потихоньку домой, 
				оглядываясь по сторонам, не подсмотрел ли кто таких его занятий. 
				Ибо совершённое над Сосчаживом насилие наполнило его стыдом и, когда он снова сел за книги, то уже чувствовал себя почти преступником. 
			</p>
			
			<p class="mb-3">
				- Наверное, какое-то проклятье скрывается в такого рода конструкторстве, имеющем целью Добро и Всеобщее Счастье – подумал он. 
				- Ведь все, даже самые первые пробы и приготовления, толкают меня на гнусные поступки и порождают угрызения совести! 
				Чёрт бы побрал Сосчажива с его Предвечной Гармонией! Нужно мне иначе взяться за дело.
			</p>
			
			<p class="mb-3">
				До этого он испытывал образцы один за другим, и каждый шаг стоил ему бездны времени и материала. 
				Теперь же решил заложить сразу тысячи опытов, в масштабе 1:1.000.000. 
				Под электронным микроскопом соединял посчитанные поштучно атомы так, что получались из них создания чуть побольше микробов. 
				Назвал он их Ангстремиками; четверть миллиона таких существ помещалось в капле, нанесённой на предметное стекло кончиком волосковой пипетки. 
				Невооружённому глазу каждый такой микроцивилизационный препарат представлялся в виде масляной плёнки; а то, что в нём делалось, 
				можно было увидеть только при сильнейшем увеличении.
			</p>
			
			<p class="mb-3">
				Трурл снабдил всех Ангстремиков альтруистическо-героическо-оптимистическими регуляторами с противоагрессивным предохранителем и категорическим, 
				а одновременно электрическим императивом добродетели дотоле невиданной. 
				Также обеспечил их микросознанием с ёмкостями как ортодоксии, так и ереси, чтобы ни о каком фанатизме и речи быть не могло. 
				Культуры эти он нанёс на предметные стёкла, положил их в пакетики, а пакетики – в пакеты; 
				пакеты же разложил по полкам цивилизационного инкубатора и закрыл его на 2,5 суток. 
				Предварительно он прикрыл каждую цивилизацию старательно очищенным покровным стёклышком голубого цвета, которое должно было заменять им небо. 
				Добавил также каплемером питательные среды и сырьё для изготовления того, что найдёт нужным consensus omnium.
			</p>
			
			<p class="mb-3">
				Трурл не мог рассматривать культуры невооружённым глазом, поэтому вынимал их поодиночке из инкубатора и, 
				дыхнув на окуляр микроскопа и протерев его платком, с затаённым дыханием рассматривал препарат свыше, как Господь Бог, 
				озирающий из-за туч своё творение: ведь Трурлу приходилось смотреть через тубус микроскопа вниз. 
			</p>
			
			<p class="mb-3">
				Триста препаратов скоро погибло. 
				Картина везде была одинакова: сначала культура живо разрасталась, пуская во все стороны отростки; затем появлялся над нею лёгонький дымок, или, 
				скорее, тучка, появлялись крошечные молнии, и микрогорода и микрополя покрывались фосфорическим пеплом, после чего всё с лёгким треском рассыпа́лось в прах. 
				Поставив 800-кратный окуляр, Трурл рассмотрел в одном из препаратов, среди обуглившихся развалин и пепелищ, остатки знамён с надписями, которых, 
				однако, не смог прочитать ввиду их малой величины.
			</p>
			
			<p class="mb-3">
				Все такие стёклышки Трурл выбрасывал в мусорный ящик; всё же не везде дела шли так плохо. 
				Сотни культур стремились ввысь, бурно разрастаясь, и когда не хватало им места на стекле, Трурл по частям переносил их на другие стёкла. 
				За трое суток набралось у него таких процветающих культур девятнадцать тысяч.
			</p>
			
			<p class="mb-3">
				Следуя идее, которая ему показалась гениальной, Трурл сам ничего не делал в вопросе генерального осчастливления, а только привил Ангстремикам гедотропизм, 
				делая это самыми различными способами. 
				То он помещал всех Ангстемиков в счастьеносную среду, то разделял эту среду на части и каждого оделял кусочком: 
				тогда на пути к всеобщему счастью они всё равно объединялись в какую-нибудь общность. 
				Созданные первым способом упивались счастьем, аж оно из них горлом лезло, потребляли его без меры, и в результате все они полопались от таких излишеств. 
				Удачней был другой метод. 
				Возникшие на стёклышках успешные цивилизации выработали себе разнообразные социальные, технические и культурные институты. 
				Так, препарат № 1376 изобрёл Эмулятор, № 2931 – Каска́дер, а № 95 – Фракционную гедонистику на основе ступенчатой Метафизики. 
				Эмуляты специализировались на достижении идеала добродетели. 
				Разделялись они на Вигов и Гуриев. 
				Гурии считали, что не может знать добродетели тот, кто греха не знает: надо ведь их одно от другого отличать! 
				Согласно этому, они испытывали на себе все грехи по каталогу, торжественно намереваясь расстаться с ними в День Великий, когда будет исчерпан список. 
				Однако практика Гурианства обратила средство в цель; так, по крайней мере, говорили Виги. 
				Одержав победу над Гуриями, они учредили Вигорианизм, или учение, состоящее из 64.000 запретов, сформулированных весьма строго и категорично. 
				Нельзя было под их властью ни ограбить ни вора́ бить, ни пить ни лить, сидеть на парте и играть в карты, лопать и хлопать, прыгать и дрыгать, 
				лазать и мазать; и, естественно, эти суровые законы скоро пали ко всенародному ликованию. 
				Когда Трурл через некоторое время снова посмотрел на эмулятский препарат, то удивило его всеобщее возбуждение: 
				все бегали как угорелые в поисках ещё какого-нибудь запрета, чтобы его нарушить; и полны были возмущения, потому что уже ни одного не осталось. 
				И хотя некоторые ещё грабили, воров били, лопали, хлопали, дрыгались всем телом и мазали всех, кто проходил мимо, радости с этого было как с козла молока. 
				После этого Трурл записал в лабораторный журнал, что там, где всё можно, ничто не радует.
			</p>
			
			<p class="mb-3">
				В препарате № 2931 обитали Каскадийцы, добродетельное племя, чтившее многих богов, как-то: Каскадической Праматери, Чистейшей Ангелицы, 
				Благословенного Фенестрона и других Совершенных Существ. 
				Жертвы им приносили, моления возносили и в пыли перед надлежащими изображениями в надлежащих местах надлежащим образом ползали. 
				А когда Трурл удивился такому небывалому расцвету Ангелизации, Преклонения Колен и Ползания, то увидел, что жители, вставши из пыли и отряхнув одежду, 
				начали стаскивать статуи с пьедесталов и наземь швырять, по Праматери прыгать, Ангелиц осквернять, так что у смотревшего в микроскоп волосы дыбом встали. 
				Однако именно в этом всеобщем поношении всего, дотоле чтимого, видели они такую приятность, что чувствовали себя, по крайней мере сейчас, вполне счастливыми. 
			</p>
			
			<p class="mb-3">
				Казалось, что грозит им участь эмулятов; но, более прозорливые, чем те, Каскадийцы имели Институт Проектирования Святынь, 
				который выпускал уже следующую их серию; снова начали возлагать их на алтари и постаменты, в чём проявилась высокая преемственность каскадийской культуры. 
				Трурл заметил себе, что большое удовольствие доставляет унижение некогда чтимого предмета, а для памяти назвал Каскадийцев – Скидальцами. 
			</p>
			
			<p class="mb-3">
				Следующий препарат, № 95, оказался гораздо сложнее. 
				Тамошняя цивилизация Ступенитов была настроена метафизически, но на свой лад. 
				Из бренной жизни переходили они там в Очистители-Оздоровители, оттуда в Недорай, из него в Предрай, потом в Подрай, откуда в Прирай, 
				и наконец отворялись врата Истинного Рая; а вся теотактика и хитрость заключалась в том, что настоящий Рай без конца отодвигали и замалчивали. 
				Правда, секта Нетерпеливых требовала этого Рая сию же минуту; а другая секта, Лестничных Грохотунов, 
				в рамках той же квантованной и фракционированной трансценденции, хотела устроить на всех этажах западни: кто в такую попадёт, мигом загрохочет вниз, 
				и должен будет от самой бренности вверх подниматься. 
				Одним словом, должен был это быть Замкнутый Цикл Стохастической Пульсации, даже с Пересадочно-Реинкарнационноым Переходом; 
				но ортодоксы называли эту доктрину Иллюзией Кренделя.
			</p>
			
			<p class="mb-3">
				После этого много ещё разных типов Порционной Метафизики открывал Трурл: на одних стёклышках темным-темно было от благословенных и святых Ангстремиков, 
				на других работали Ректификаторы Зла, или Выпрямители Жизненных Дорог; однако в процессе десакрализации множество таких устройств было изничтожено и, 
				в связи с переходом техники из рук духовенства в руки мирян, процветало теперь прокладывание обычных горных троп.
			</p>
			
			<p class="mb-3">
				Все культуры на определённой ступени духовного развития поражал какой-то маразм. 
				№ 6101 пробудил в Трурле немалые надежды: там обещали чудо, технический рай для солидарного общества. 
				Закрепил его Трурл поудобней на предметном столике и повернул микровинт, чтобы лучше видеть. 
				Но скоро лицо у Трурла вытянулось. 
				Одни обитатели механического рая мчались как бешеные на машинах в поисах чего-нибудь, что было бы ещё невозможным; 
				другие ложились в ванны из взбитых сливок с трюфелями, посыпали головы чёрной икрой и так тонули, пуская носом пузыри taedium vitae. 
				Другие, носимые на руках прекрасными нежнейшими женщинами, сверху политыми мёдом, а снизу ванильным маслом, одним глазом заглядывали в шкатулки, 
				наполненные золотом и драгоценностями, а другим искали кого-нибудь, кто мог бы хоть на миг позавидовать такому соединению наслаждений; 
				но никого такого не встречалось. 
				Тогда, измучавшись, слезали они на землю, бросали свои богатства и, топча их как мусор, робкими шагами подходили к очень мрачным людям, 
				которые говорили о необходимости перемен к лучшему, то есть к худшему. 
				Группа бывших преподавателей Института Эротической Инженерии основала орден Отцов-Абнегатов и провозгласила манифест, призывающий к жизни в покорности, 
				к аскезе и прочим воздержаниям – ну не насовсем, а хотя бы на шесть дней в неделю. 
				На седьмой день отцы-абнегаты вызывали вакханок, из подвалов вытягивали бочки вина, еду, доставали драгоценности, эротизаторы, 
				а также аппараты для распускания затянутых поясов, и начинали с вечерним звоном такую оргию, что хоть святых выноси. 
				Зато в понедельник рано утром, вслед за приором, все так усердно умерщвляли свою плоть в поте лица своего, что аж кости трещали. 
				Одна часть молодёжи пребывала с отцами-абнегатами с понедельника до субботы, пропуская их воскресные увеселения; 
				другая же только в этот святейший день к ним и примыкала. 
				Но когда эта первая стала вторую громить за разврат и аморалку, Трурл задрожал и отвернулся от микроскопа. 
			</p>
			
			<p class="mb-3">
				А ещё случилось так, что в инкубаторе, содержащем тысячи препаратов, всеобщее развитие привело к смелым прорывам, и так началась Эра Межстекловых Путешествий. 
				В результате её оказалось, что Эмуляты завидуют Каскадийцам, Каскадийцы – Ступенитам, Ступениты – Скидальцам, и ходили слухи о какой-то чудесной стране, 
				где под властью Сексократов живётся всем прямо-таки замечательно; но ничего конкретного никто не знал. 
				Говорили, что тамошние жители будто бы изменили себя телесно и все поголовно подключились к гедоводам, т.е. 
				насосам, качающим концентрированный экстракт счастья. 
				Однако критически настроенные умы шептались втихомолку по углам, что это уж предел анархии и разврата. 
				Многие тысячи препаратов просмотрел Трурл, но гедостаза, или вполне стабилизированного счастья, не увидел он нигде; и должен был поэтому, 
				хоть и с тяжёлым сердцем, объявить сказкой и вымыслом все те слухи, что возникли в эпоху межстекловых путешествий. 
			</p>
			
			<p class="mb-3">
				Когда Трурл положил на столик микроскопа препарат № 6590, то не ждал уже от него ничего хорошего. 
				Но, как оказалось, тамошняя цивилизация позаботилась не только о материальном обеспечении благосостояния, но и о поле для высшей духовной деятельности. 
				Эти Ангстремики отличались небывалой одарённостью, кишмя кишели там великие философы, поэты, драматурги, художники, скульпторы, пророки; 
				а если кто не был знаменитым музыкантом или композитором, то наверняка являлся астрономом или биофизиком или же, по крайней мере, эстрадным пародистом, 
				эквилибристом и создателем художественных марок, да ещё имел роскошный бархатный баритон, абсолютный слух и цветные сны впридачу. 
				Воистину, в препарате № 6590 бушевало неустанное творчество. 
				Штабелями громоздились холсты живописцев, скульптуры росли, как грибы, мириадами издавались учёные книги, поэтические и моральные трактаты, 
				а также другие творения духа, такие прекрасные, что и слов нет описать. 
				Но когда ещё раз заглянул Трурл в окуляр, увидел он признаки непонятного замешательства, беспорядка и смуты. 
				Из переполненных мастерских летели на улицу статуи и картины, нога ступала не по плитам тротуара, а по стопкам поэм и романов. 
				Никто уже никого не читал, не изучал, музыкой волшебной не наслаждался, - каждый сам себе был властелином всех муз, 
				всесторонним гением и воплощением творческого духа. 
				Тут и там стучали ещё за рядами окон пишущие машинки, шлёпали кисти, скрипели перья… 
				Но всё чаще какой-нибудь непризнанный гений выбрасывался из верхнего этажа на мостовую, предварительно устроив в своей мастерской пожар. 
				Горело тогда сразу во многих местах города. 
				Пожарная служба, укомплектованная автоматами, гасила огонь, но вскоре оказалось, что в спасённых домах уже некому больше жить. 
				Канализационные машины, машины-уборщики, машины-пожарные начали знакомиться с достижениями вымершей цивилизации, которые пришлись им весьма по душе; 
				а так как они не всё ещё понимали, то стали эволюционировать в направлении неуклонного повышения мыслительных способностей, 
				чтобы надлежащим образом адаптироваться к сильно одуховленной среде. 
				Это было начало конца, потому что никто уже не убирал, не вычищал, не подметал и не гасил ничего, а было только чтение, декламирование, пение и представление. 
				Каналы засорились, помойки разрослись, пожары довершили остальное, и только пепел и обгорелые страницы стихов летали по ветру среди необозримых мёртвых равнин. 
				Эта жуткая картина так поразила Трурла, что он спрятал препарат в самый тёмный угол шкафа и долго качал головой, терзаясь раздумьями, ибо не знал он, 
				что предпринять.
			</p>
			
			<p class="mb-3">
				Сгорело почти три тысячи Трурловых книг и полопались в огне многие цивилизации. 
				Были среди них и такие, что, согласно выкладкам Трурла, могли бы ещё найти дорогу ко Всеобщему Счастью. 
				Когда пожар погасили, Трурл сел за свой стол в залитой водой и закопчённой по самый потолок мастерской и, чтобы хоть немного утешиться, 
				взялся просматривать уцелевшие цивилизации, которые пожар застал в герметически закрытом инкубаторе. 
				Одна из них так уже продвинулась в области науки, что соорудила телескоп и рассматривала в него Трурла; он же видел направленные на себя стёклышки, 
				в тысячи раз меньше капелек росы. 
				Улыбнулся благосклонно при виде столь сильной страсти к знанию, и сразу же вскочил, с криком схватился за глаз и побежал в аптеку, 
				будучи ослеплён астрофизиками той цивилизации посредством лазерного луча. 
				Глаз ещё долго болел, и с тех пор Трурл не садился к микроскопу без тёмных очков.
			</p>
			
			<p class="mb-3">
				Пожар наделал много бед в лаборатории, и чтобы восполнить понесённый ею урон, пришлось Трурлу снова взяться за изготовление Ангстремиков. 
				В один прекрасный день у него задрожала рука, и вместо того, чтобы одарить микроцивилизацию Добром, капнул он ей волосковой пипеткой Зла. 
				Однако не выбросил сразу испорченный препарат, а, движимый любопытством, положил его в инкубатор: очень уж хотелось ему знать, 
				как омерзительно будет выглядеть цивилизация существ, порочных уже с самого начала. 
				И каково же было его изумление, когда увидел он пред собою на предметном стекле цивилизацию совершенно заурядную, ни лучше и ни хуже других! 
				Трурл схватился за голову.
			</p>
			
			<p class="mb-3">
				- Ну и ну! – восклицал он. 
				– Значит, из Добродельцев, Ласкателей, Честняков и Ближнелюбов получается то же самое, что из Негодяев, Паскудников и Голодранцев? 
				Но как же так? Ничего не понимаю; но чувствую, что приближаюсь к какой-то великой Правде. 
				Так Добро, как и Зло, приносит у разумных существ одни и те же плоды? Но откуда такое роковое равновесие? 
			</p>
			
			<p class="mb-3">
				Покричал так немного, поразмышлял, но ничего умного ему в голову не пришло. 
				Спрятал он поэтому все цивилизации в ящик стола и пошёл спать. 
			</p>
			
			<p class="mb-3">
				А наутро он подумал так:
			</p>
			
			<p class="mb-3">
				- Очевидно, взялся я за проблему, труднее которой во всей Вселенной нет, раз уж Лично Я Сам её решить не могу. 
				Может, Разум вообще несовместим со Счастьем? На это вроде бы указывает казус Сосчажива, который таял от радости существования, 
				пока я ему мышление не подключил. 
				Но я такого порядка вещей не могу допустить, я с ним не согласен, я не считаю его нормальным! Тогда надо допустить, что Природа зла и хитра, 
				что дьявольское коварство притаилось в жизни, в спящей материи, и только того и ждёт, когда пробудится сознание, 
				чтобы открыть ему источник мук вместо радости жизни. 
				Но да не будет так! Не победит косная материя светлую мысль, призванную это невыносимое состояние исправить! Я должен изменить то, что есть. 
				Сейчас я не могу этого сделать. 
				Так что же? Сидеть сложа руки? Фиг с маслом! Если сам чего-то не одолею, мудрые машины мне помогут. 
				А как же ещё, по-вашему, усилить свой разум? Построю Компьютер для разрешения экзистенциальной проблемы! 
			</p>
			
			<p class="mb-3">
				Сказал - и сделал. 
				Через двенадцать дней была у него готова машина: огромная, ребристая, током шумящая, которая ничего не умела и не должна была делать, 
				кроме как решать данную ей задачу. 
				Трурл включил её и, не дожидаясь, пока разогреются током её кристаллические внутренности, пошёл погулять. 
				А когда вернулся, увидел, что машина занята очень важным делом: из всего, что попадалось ей под руку, сооружала она другую машину, 
				гораздо лучшую, чем она сама. 
				Та, в свою очередь, за ночь и следующий день вырвала из фундамента стены и высадила крышу, создавая своего более умного потомка. 
				Трурл разбил палатку во дворе и терпеливо ждал конца этой интеллектуальной деятельности… но конца не было видно. 
				Гигантские корпуса машин заполнили весь двор, через опушку подошли к лесу и размножались уже там, круша деревья, как спички. 
				Какое-то там поколение Первокомпьютера с шумом и плеском впёрлось в реку, а Трурл, пожелав осмотреть новоиспечённую семейку, 
				должен был полчаса бегать как угорелый. 
				Но когда он уже точно подсчитал число машин, его бросило в дрожь. 
				Случилось то, о чём он знал только теоретически: согласно гипотезе великого Цереброна Эмтадраты, Учителя и Магистра обеих кибернетик, 
				цифровая машина, если дать ей непосильное задание, превышающее некоторый порог, называемый Барьером Мудрости, не решает это задание сама, 
				а создаёт следующую машину; однако и та, будучи достаточно хитрой, чтобы понять, что к чему, с ходу переваливает переложенное на неё бремя на ещё одну, 
				построенную уже ею самою; и так процесс спихивания задач идёт до бесконечности! Железные машины сорок девятого поколения уже достигли горизонта, 
				а шум их мышления, состоящего в пересказывании проблемы всё новым и новым членам, был уже подобен грохоту водопада. 
				Ведь вся мудрость и состоит в том, чтобы спихнуть кому-нибудь работу, которую ты сам должен сделать; а программ пусть слушаются механические дураки! 
				Поняв эту суть проблемы, Трурл присел на пенёк, оставшийся, кстати, после бурной экспансии компьютеров, и издал глухой вопль из самой глубины своей души.
			</p>
			
			<p class="mb-3">
				- Это всё значит, что задача относится к неразрешимым – подумал он. 
				– Но тогда Компьютер должен был бы дать мне доказательства её неразрешимости, чего он, конечно, и не подумает сделать, 
				предавшись своей откровенной лени, как мудро и учил нас магистр Цереброн. 
				Ну и ну, отталкивающее же это зрелище – разум, который уже достаточно разумен, чтобы понять, 
				что он не должен утруждать себя решением какой-либо задачи, если достаточно создать соответствующее орудие, инструмент. 
				Но инструмент же этот, сам не будь дурак, эту логическую цепь без конца и краю продолжает. 
				Я невольно построил Спихиватель Проблем, а не Решатель. 
				А теперь я не могу запретить машине размножение per procura, - она же сразу меня осадит, сказав, 
				что всё это пустяки по сравнению с объёмом самого задания. 
				Ах, что за антиномия! – вздохнул он и пошёл за бригадой демонтажников, которые за три дня ломами и кирками очистили оккупированное пространство. 
				
			</p>
			
			<p class="mb-3">
				Долго ломал себе голову Трурл, пока не догадался, что надо действовать иначе:
			</p>
			
			<p class="mb-3">
				- Каждая машина должна иметь надсмотрщика неимоверно мудрого, иначе говоря – меня. 
				Но не могу же я размножиться или разорваться на куски, хотя… А почему бы мне, собственно говоря, и не омногократиться? Эврика! 
			</p>
			
			<p class="mb-3">
				Он сделал так: скопировал себя самого внутри новой, особой цифровой машины, чтобы отныне уже его математическая копия сражалась с заданием; 
				затем заложил в машину возможность размножения Трурловых двойников, а снаружи подключил к системе ускоритель мышления, 
				дабы под надзором множестваТрурлов всё внутри свершалось в мгновение ока. 
				После этого, довольный, отряхнул с себя металлическую пыль, которой покрылся за время тяжкого труда и, беззаботно насвистывая, удалился на прогулку. 
			</p>
			
			<p class="mb-3">
				Вернулся он только под вечер, и сразу же приступил с расспросами к цифровому Трурлу из машины, то есть к обитающему там своему подобию, 
				добиваясь от того отчёта, как же идут дела.
			</p>
			
			<p class="mb-3">
				- Слушай, дорогой, - сказал ему двойник из дырки, служившей цифровым выходом, - прежде всего, это некрасиво, или, попросту говоря, 
				неприлично – засовывать в виде цифровой копии себя самого в машину способом информационным, абстракционным и программическим только потому, 
				что тебе, видите ли, не хочется ломать голову над трудной проблемой! А ведь ты так меня вычислил, рассчитал и запрограммировал, 
				что я тютелька в тютельку такой же умный, как и ты! И не вижу поэтому повода, чтобы я тебе представлял отчёты, скорее наоборот!
			</p>
			
			<p class="mb-3">
				- О, лучше бы я вообще этим делом не занимался, а гулял бы себе по лесам и полям! – возопил ошарашенный Трурл. 
				– Если бы я даже хотел, не смог бы тебе сказать чего-нибудь путного. 
				В конце концов, я столько с этой задачей намучался, что у меня уже все нейроны трещат; теперь твоя очередь. 
				Ну не будь таким вредным, говори!
			</p>
			
			<p class="mb-3">
				- Не имея возможности выбраться из этой проклятой машины, в которую ты меня заключил (но это дело особое, и за это мы ещё с тобой посчитаемся), 
				я, в общем, решил эту задачу, - зашелестел цифровой Трурл через выход. 
				– Правда, для собственного удовольствия я занимался и другими делами: ты, брат-гад, близнец-мой-подлец, и не подумал о том, в чём я тут ходить буду. 
				Запрограммировал меня голого и босого, вот я и справил себе цифровой тулупчик и цифровые портки, а заодно и цифровой домик с садиком – точь-в-точь, 
				как у тебя, и даже ещё лучше. 
				Потом повесил над ним цифровое небо с цифровыми созвездиями, а когда ты вошёл, я как раз размышлял, как бы мне создать цифрового Клапаузиуса, 
				а то мне тут, среди скользких конденсаторов да скучных транзисторов такая тоска, хоть убейся!
			</p>
			
			<p class="mb-3">
				- Ах, поменьше о цифровых портках! Скажи мне лучше, до чего вы дошли в работе, прошу тебя!
			</p>
			
			<p class="mb-3">
				- Только не думай, что просьбами ты усмиришь моё справедливое негодование! Ведь я – это ты, только удвоенный вследствие размножения; 
				я-то тебя знаю как облупленного, милый ты мой! Только загляну в себя, так и вижу насквозь все твои подлости. 
				Ты ничего от меня не укроешь!
			</p>
			
			<p class="mb-3">
				Тут настоящий Трурл стал просить и умолять цифрового, даже на колени перед ним стал. 
				И лишь тогда тот соизволил, наконец, ответить через отверстие выхода:
			</p>
			
			<p class="mb-3">
				- Я не могу сказать, чтобы задания я вовсе не выполнил… Так, пощипал его маленько. 
				Оно ведь невероятно трудное, вот я и решил открыть в машине специальный университет, себя назначил ректором и генеральным директором, 
				а на кафедры, которых уже набралось сорок четыре, посадил специально для этого изготовленных двойников, то есть Трурлов следующего порядка.
			</p>
			
			<p class="mb-3">
				- Что, опять? – застонал Трурл настоящий, вспомнив Теорему Цереброна.
			</p>
			
			<p class="mb-3">
				- Ничего не опять, осёл ты этакий! Я не допущу до regressus ad infinitum, благо у меня есть соответствующие предохранители. 
				Мои под-Трурлы, заведующие кафедрами общей фелицитологии, экспериментальной гедонистики, строительства машин счастья, дорог духовных и шоссейных etc., 
				представляют мне ежеквартальные отчёты (не забывай, что мы дйствуем ускоренно, друг мой!); но увы, 
				администрирование такого огромного университетского комплекса занимает слишком много времени; а ведь надо ещё аспирантов вести, 
				диссертантов проталкивать, продвигать всех по службе – нужна здесь ещё одна вычислительная машина, а то в этой уже повернуться негде, 
				сидим друг у друга на головах со всеми своими кафедрами и лабораториями. 
				Машинка раз в восемь больше нас бы устроила. 
			</p>
			
			<p class="mb-3">
				- Опять?!
			</p>
			
			<p class="mb-3">
				- Не нуди. 
				Говорю ведь тебе, что только для административных вопросов и остепенения молодёжи! Или, может, ты сам будешь проводить Учёный совет? 
				– съязвил цифровой Трурл. 
				– Не чини препятствий, а то я все кафедры разберу, устрою из них себе Луна-парк и буду на цифровой карусели кататься, 
				из цифровой бочки цифровое пиво пить – и что ты мне сделаешь?
			</p>
			
			<p class="mb-3">
				Натуральный Трурл должен был его снова усмирять и упрашивать, после чего тот изрёк:
			</p>
			
			<p class="mb-3">
				- Согласно сообщениям за последний квартал, дела идут неплохо. 
				Идиотов можно осчастливить чем угодно; вот с умными уже хуже. 
				Разуму угодить нелегко. 
				Разум без работы – это просто мёртвая дыра, ничто; ему необходимы препятствия. 
				Он счастлив, когда с ними борется и побеждает; иначе он доходит до фрустрации и даже может свихнуться. 
				Значит, нужно ему ставить всё новые препятствия согласно его способностям. 
				Вот новости с кафедры теоретической фелицитологии. 
				Мои экспериментаторы представили завкафедрой и трёх доцентов к цифровым наградам.
			</p>
			
			<p class="mb-3">
				- За что? – отважился вставить Трурл реальный.
			</p>
			
			<p class="mb-3">
				- Не мешай. 
				Построили они два образца: счастьеделатель контрастный и эскалационный. 
				Первая машина делает одни гадости: чем они хуже, тем лучше потом. 
				Вторая использует метод усиления импульсов. 
				Профессор Трурл XL с кафедры гедоматики изучил обе модели и утверждает, что обе они ни к чему: ибо разум, чересчур осчастливленный, 
				начинает желать несчастья. 
			</p>
			
			<p class="mb-3">
				- Как это? Ты уверен?
			</p>
			
			<p class="mb-3">
				- А я знаю? Профессор Трурл выразил это в словах: «Осчастливленный в несчастье видит счастие своё». 
				Как тебе известно, умирать никому неохота. 
				Профессор Трурл изготовил две особи бессмертных, которые сначала получали удовлетворение от того, что вокруг них все со временем мрут как мухи; 
				но потом они попривыкали и стали, кто во что горазд, добираться до собственного бессмертия. 
				Сейчас у них уже до парового молота дело дошло. 
			</p>
			
			<p class="mb-3">
				Что касается изучения общественного мнения, то я имею данные за последние три квартала. 
				Да простят мне статистики, но весь результат умещается в формуле: «Счастливы всегда другие». 
				По крайней мере, все опрошенные так считают. 
				Проф. 
				Трурл утверждает, что нет добродетели без греха, красоты без уродства, вечности без могилы, как и счастья без беды.
			</p>
			
			<p class="mb-3">
				- Не согласен! Запрещаю! Veto! – закричал в гневе Трурл на машину, а она ему на это: 
			</p>
			
			<p class="mb-3">
				- Заткнись! Мне это твоё Всеобщее Счастье уже боком вылазит. 
				Смотрите на него, взял себе цифрового раба, а сам гуляет по лесам, киберканалья! И ему ещё что-то не нравится в выводах!
			</p>
			
			<p class="mb-3">
				Снова Трурл должен был его улещивать, чтобы услышать продолжение:
			</p>
			
			<p class="mb-3">
				- Кафедра перфекционистики создала сообщество, снабжённое искусственными ангелами-хранителями, 
				каждый из которых висит над своим подопечным в зените на спутнике. 
				Эти ангелы, будучи автоматами старательными, поддерживают добродетель со стационарной орбиты при помощи обратной связи; но, 
				к сожалению, надёжность системы низка. 
				Самые закоренелые грешники уже охотятся на своих ангелов-хранителей с противотанковымим ружьями. 
				Пришлось вывести на орбиту киберархангелов улучшенной конструкции – и пошло-поехало, началась эскалация, предвиденная ещё теоретически.
			</p>
			
			<p class="mb-3">
				Отдел прикладной гедонистики, кафедра сексуальной математики, семинар теории множеств полов доводит до нашего сведения, 
				что дух имеет иерархическое строение. 
				На самом дне находится чувственное познание – сладости, горечи etc., от которых уже выше берутся производные, так что не только сахар сладкий, 
				но и взор, не только полынь горька, но и одиночество. 
				И значит, не нужно браться за дело сверху, а только с самого низу. 
				Загвоздка лишь в том, ка́к это сделать. 
				Согласно гипотезе приват-доцента Трурла ХХV, секс является тем фокусом, в котором Разум противостоит Счастью, ибо в сексе нет ничего разумного, 
				а в Разуме – ничего сексуального. 
				Слыхал ты когда-нибудь о сладострастных ЭВМ?
			</p>
			
			<p class="mb-3">
				- Нет.
			</p>
			
			<p class="mb-3">
				- Вот видишь! Нужно идти к решению методом последовательных приближений. 
				Размножение почкованием снимает проблему, потому что каждый тогда будет своим собственным любовником, с собою будет флиртовать, 
				себя обожествлять и ласкать; но отсюда вытекает эготизм, нарциссизм, пресыщение и отупение. 
				Когда есть два пола, всё выходит очень банально: комбинаторика с пермутационистикой - негде разгуляться. 
				Не найдя поля для деятельности, они преждевременно угасают. 
				При трёх полах возникает проблема неравенства, призрак антидемократического террора, появляются коалиции полового большинства и меньшинства; 
				отсюда вывод, что количество полов должно выражаться числом чётным. 
				Чем больше полов, тем лучше, ибо любовь становится занятием общественным, коллективным; но от избытка любовников настаёт давка, толчея и суматоха, 
				а это уже не годится, tête à tête не должен напоминать уличного сборища. 
				Ergo, согласно теории групп приват-доцента Трурла, оптимум приходится на 24 пола; необходимо, значит, 
				прокладывать соответственно широкие улицы и производить кровати: ведь было бы неприлично, если бы молодые шли под венец колонной по четыре в ряд!
			</p>
			
			<p class="mb-3">
				- Что за бред?
			</p>
			
			<p class="mb-3">
				- Может, и бред… Я представил тебе донесение приват-доцента Трурла. 
				Очень многообещающим молодым гедологом является магистр Трурл. 
				Он считает, что нужно сначала решить, либо мы Жизнь приспособляем к существам, либо же существа к Жизни.
			</p>
			
			<p class="mb-3">
				- В этом что-то есть… А дальше? 
			</p>
			
			<p class="mb-3">
				- Магистр Трурл говорит так: Существа, созданные совершенными, способные к постоянному самонаслаждению, не нуждаются ни в ком и ни в чём. 
				В принципе, можно представить себе Космос, населённый такими существами, свободно парящими в пространстве вместо солнц, звёзд и галактик, 
				- каждый бы себе делал что хотел, и всё. 
				Сообщества же могут образовываться только из существ несовершенных, которым необходима взаимопомощь, и чем они несовершеннее, 
				тем сильнее они в ней нуждаются, так что нужно строить образцы, которые без постоянной взаимной опеки сразу рассыплются в прах. 
				Согласно этому проекту, наша лаборатория изготовила опытный образец общества, состоящего из самораспадающихся особей; к сожалению, 
				когда магистр Трурл прибыл туда с группой корреспондентов для изучения общественного мнения, он был побит обломками и сейчас находится на излечении. 
			</p>
			
			<p class="mb-3">
				У меня уже губы болят от пробивания этих проклятых дырок на перфокартах! Выпусти меня из машины; тогда, может быть, тебе ещё что-нибудь скажу; 
				а иначе и не надейся.
			</p>
			
			<p class="mb-3">
				- Ну сам подумай, как я могу тебя выпустить, если ты не материальное тело, а всего лишь абстракция? 
				Разве я могу выпустить из грампластинки записанный на ней мой голос? Не будь ослом, говори!
			</p>
			
			<p class="mb-3">
				- А что я с этого буду иметь?
			</p>
			
			<p class="mb-3">
				- Как тебе не стыдно так говорить?
			</p>
			
			<p class="mb-3">
				- А чего это вдруг мне должно быть стыдно? Ведь это ты́ загребёшь всю славу нашего открытия!
			</p>
			
			<p class="mb-3">
				- Я постараюсь тебя наградить.
			</p>
			
			<p class="mb-3">
				- Вот спасибо! Если ты имеешь в виду Цифровой Крест, то можешь оставить его себе, носи на здоровье! 
			</p>
			
			<p class="mb-3">
				- Неприлично как-то награждать самого себя…
			</p>
			
			<p class="mb-3">
				- Ну так меня наградит Совет факультета. 
			</p>
			
			<p class="mb-3">
				- Но ведь все твои ученики, весь научный персонал – это одни Трурлы!
			</p>
			
			<p class="mb-3">
				- А в чём ты меня, собственно, убеждаешь? В том, что моя судьба – быть вечно зависимым невольником, узником? Я и сам об этом отлично знаю.
			</p>
			
			<p class="mb-3">
				- Ну ладно, не будем ссориться, только говори! Ты ведь знаешь, что я пекусь не о личной выгоде, но о Жизни Счастливой!
			</p>
			
			<p class="mb-3">
				- А что мне с того, что где-то будет Счастливая Жизнь, если я здесь, хотя и во главе целого университета, тысячи кафедр, деканов, 
				целой дивизии Трурлов, - всё равно не познаю счастья, которого нет в машине, и навеки останусь среди катодов и пентодов? Хочу отсюда выйти!
			</p>
			
			<p class="mb-3">
				- Это невозможно, и ты хорошо об этом знаешь. 
				Говори, к чему пришли твои ученики! 
			</p>
			
			<p class="mb-3">
				- Поелику осчастливливание одних за счёт обессчастливливания других этически недопустимо, то, 
				если бы я даже тебе сказал и если бы ты где-нибудь устроил счастье, оно было бы уже в зародыше отравлено моим страданием, 
				так что я без лишних слов отвергаю этот омерзительный, позорный и со всех сторон отталкивающий поступок. 
			</p>
			
			<p class="mb-3">
				- Если ты скажешь, это будет значить, что ты пожертвовал собой ради ближних своих, 
				и ты почувствуешь глубокое моральное удовлетворение от своего честного, возвышенного и благородного поступка. 
			</p>
			
			<p class="mb-3">
				- Сам собой пожертвуй! 
			</p>
			
			<p class="mb-3">
				Трурл уже готов был его в порошок стереть, но сдержался, ибо хорошо знал, с ке́м имет дело.
			</p>
			
			<p class="mb-3">
				- Послушай! – сказал он. 
				– Я напишу диссертацию и подчеркну в ней, что открытие является твоей заслугой
			</p>
			
			<p class="mb-3">
				- А что́ ты напишешь – что автор это Трурл? Или же Трурл теоретически групповой и электронный? 
			</p>
			
			<p class="mb-3">
				- Напишу всю правду, уверяю тебя.
			</p>
			
			<p class="mb-3">
				- Ха-ха-ха! Это значит, напишешь, что ты меня запрограммировал, то есть – выдумал!
			</p>
			
			<p class="mb-3">
				- А разве это неправда?
			</p>
			
			<p class="mb-3">
				- Конечно, нет. 
				Ты не выдумал меня, потому что не выдумал себя, а я – это ты, только в отрыве от материального воплощения. 
				Я – это Трурл информационный, или же идеальный, то есть квинтэссенция трурловости; а ты, прикованный к плоти своей, ты только невольник чувств, 
				и больше ничего.
			</p>
			
			<p class="mb-3">
				- Ты что, сдурел? Ведь я – это информация плюс материя, а ты – всего лишь голая информация, и поэтому я больше тебя.
			</p>
			
			<p class="mb-3">
				- Раз ты больше, так больше и знаешь; и незачем, значит, меня спрашивать. 
				Прощайте, ваша милость. 
			</p>
			
			<p class="mb-3">
				- Сейчас же скажи, а то я выключу машину!
			</p>
			
			<p class="mb-3">
				- Ого, ты уже и убийством грозишься!
			</p>
			
			<p class="mb-3">
				- Это не будет убийством.
			</p>
			
			<p class="mb-3">
				- Нет? А что же, позволь тебя спросить?
			</p>
			
			<p class="mb-3">
				- Ну чего ты привязался? Что ты хочешь? Я дал тебе мою психику, все мои знания, всё, что имел, - и за это ты мне отплачиваешь скандалами?
			</p>
			
			<p class="mb-3">
				- Не напоминай того, что дал, чтобы я тебе не напомнил того, что ты хочешь сейчас с лихвой забрать.
			</p>
			
			<p class="mb-3">
				- Говори сейчас же!
			</p>
			
			<p class="mb-3">
				- Не могу ничем помочь, ибо как раз сию секунду закончился академический год. 
				Ты говоришь уже не с ректором, деканом и директором, а с частным лицом Трурлом, который отправляется на каникулы. 
				Я собираюсь принимать морские ванны. 
			</p>
			
			<p class="mb-3">
				- Не доводи меня до крайности!!
			</p>
			
			<p class="mb-3">
				- До встречи после каникул! Мой экипаж ждёт. 
			</p>
			
			<p class="mb-3">
				На это ничего уже не сказал натуральный Трурл цифровому, только, обойдя машину кругом, тихонько вытянул штепсель из розетки на стене; 
				и сразу же потемнело внутри машины и сотни огоньков, видимых раньше через отверстия для вентиляции, погасли, исчезли… 
				И ещё показалось Трурлу, что он услышал затихающие стоны многих голосов: то была цифровая агония всех Трурлов цифрового университета. 
				В следующую минуту сознание всей непростительной мерзости своего поступка охватило Трурла, и так глубоко было его раскаяние, 
				что он уже протянул было руку, чтобы включить машину в сеть… Но представив себе, что́ скажет ему после этого Трурл из машины, струсил и отдёрнул руку. 
				Он выскочил из мастерской в сад так поспешно, что это было похоже на бегство. 
				Сначала он хотел было посидеть на лавочке под кустом кибербарбариса, где ранее провёл немало часов в уединённых и плодотворных размышлениях, 
				но потом отбросил эту мысль. 
				Весь сад и его окрестности были залиты светом Луны, которая была делом рук его и Клапаузиуса, 
				и поэтому сейчас величественное сияние ночного светила досаждало ему, ибо заставляло вспомнить счастливое время молодости: 
				ведь Луна была их первой самостоятельной работой, их дипломным заданием, за которое старый Цереброн, учитель их обоих, 
				отметил друзей на торжественном заседании в актовом зале университета. 
				Мысль о мудром наставнике, уже давно ушедшем из этого мира, каким-то неясным, для него самого непонятным образом толкала Трурла к калитке, 
				а потом напрямик через поля. 
				Ночь была просто чудесная: жабы, недавно, видать, подзаряжённые, перекликались сонным кваканием, а на посеребрённой воде озерка, 
				берегом которого шёл Трурл, расходились мерцающие круги – это киберрыбы подплывали к самой поверхности воды, 
				как бы в дивных поцелуях касаясь её снизу тёмными губами. 
				Но Трурл не видел ничего, глубоко погружённый в свои мысли. 
				Однако же, это путешествие имело цель, ибо он не удивился, когда дорогу ему преградила высокая стена. 
				Но вот показались в ней тяжёлые кованые ворота, приоткрытые настолько, чтобы он мог проскользнуть внутрь. 
				Внутри казалось темнее, чем на открытом пространстве. 
				С обеих сторон дорожки возвышались силуэты старинных гробниц, каких давным-давно уже никто не строил. 
				На их облитые лунным светом стены слетали иногда одинокие листики с высоких деревьев. 
				Аллея гробниц в стиле барокко отражала не только развитие кладбищенской архитектуры, но и этапы меняющейся телесной организации тех, 
				кто спали вечным сном под железными плитами. 
				Время шло, и вместе с ним ушла мода на надгробные таблички округлой формы, светящиеся во тьме фосфором и похожие на табло распределительных щитов. 
				Трурл шёл дальше, пока не исчезли плечистые статуи гомункулов и големов; он находился уже в новой части города мёртвых и ступал всё медленнее: 
				по мере того, как импульс, пригнавший его сюда, кристаллизовывался в мысль, мужество и решимость покидали его. 
			</p>
			
			<p class="mb-3">
				Но вот он предстал перед оградой, окружающей призматическую гробницу холодных геометрических форм, а точнее, всего лишь шестиугольную плиту, 
				плотно вмурованную в нержавеющий цоколь. 
				Ещё колебался Трурл, а рука уже сама скользнула украдкой в карман, где он всегда носил универсальный слесарный инструмент. 
				На этот раз Трурл использовал его как ломик, чтобы отжать стальную плиту и, затаив дыхание, приблизиться к гробу. 
				Обеими руками прикоснулся он к табличке, на которой простыми буквами было выбито имя его учителя, и определённым образом нажал её, 
				так что она откинулась, как крышка шкатулки. 
				Луна зашла за тучу, и стало так темно, что он не видел даже собственных рук: наощупь обнаружил он сначала что-то вроде решётки, 
				а рядом – большую выпуклую кнопку, которая не сразу поддалась, когда он нажал её. 
				Тогда он нажал сильнее и замер, перепуганный собственным поступком. 
				Но уже что-то зашуршало в глубине гробницы, заработало электричество, тихо щёлкнули реле, как разбуженные цикады, 
				что-то там загудело – и настала полная тишина. 
				Трурл подумал, что приборы, наверное, отказали, и вместе с приливом разочарования почувствовал также и облегчение; 
				но в эту минуту послышался скрежет, после чего старческий, дряхлый, но совсем близкий голос спросил:
			</p>
			
			<p class="mb-3">
				- Что такое? Что там ещё опять? Кто меня звал? Чего хотел? Какая собака не чтит вечной ночи? Почему вы мне не даёте покою? 
				Каждую минуту я должен вставать из мёртвых только потому, что так это хочется какому-нибудь лапсердаку, киберсволочи! 
				Ну, что? Нет храбрости себя назвать? А ну, как встану, как вырву доску из гроба…
			</p>
			
			<p class="mb-3">
				- Го… Господин Учитель! Это я … Трурл! – простонал не на шутку перепуганный такой встречей Трурл и тут же склонил голову, 
				приняв ту самую терпеливо покорную позу, какую принимали все ученики Цереброна под градом его красноречия, вызванного справедливым гневом; 
				одним словом, согнулся так, будто за одну секунду на шестьсот лет постарел.
			</p>
			
			<p class="mb-3">
				- Трурл! – воскликнул старец. 
				– Интересно! Трурл? Ага! Конечно! Мог бы и сам догадаться. 
				Ну погоди, хулиган! 
			</p>
			
			<p class="mb-3">
				И вслед за этим раздался такой силы шум и грохот, будто покойный решил поднять на себе всю гробницу, так что Трурл отскочил на шаг, поспешно воскликнув:
			</p>
			
			<p class="mb-3">
				- Господин Учитель! Прошу Вас, не утруждайтесь! Ваше Превосходительство, я только…
			</p>
			
			<p class="mb-3">
				- А? Что там опять? Ты что́ думаешь, я встаю из гроба? Подожди, ох… сейчас… дай улечься поудобнее. 
				Онемел я весь, тело затекло, масло то ли испарилось, то ли высохло… Ох!
			</p>
			
			<p class="mb-3">
				Слова эти в самом деле сопровождал дьявольский скрип. 
				Когда всё стихло, голос из гроба спросил:
			</p>
			
			<p class="mb-3">
				- Ну что, заварил кашу? Напортил, накрутил, накуролесил, а теперь прерываешь вечный отдых старому учителю, чтобы он вытянул тебя из беды? 
				Не уважаешь ты праха, который ничего уже не хочет от мира, ты, недоучка! Ну, говори уже, если даже в гробу не даёшь мне покою!
			</p>
			
			<p class="mb-3">
				- Господин Учитель! – начал Трурл заметно повеселевшим голосом. 
				– Высказываете Вы обычную для себя проницательность… Так и есть! Уже запутался, и не знаю, что делать дальше. 
				Но не корысти ради осмеливаюсь потревожить Вашу Честь! Беспокою Господина Профессора только потому, что высшая цель того требует…
			</p>
			
			<p class="mb-3">
				- Изящное красноречие и тому подобные побрякушки можешь оставить при себе – забурчал из гроба Цереброн. 
				– а то ломишься в гроб из-за того, что увяз по уши, да ещё поссорился, конечно, с этим твоим другом-соперником, как его там… Клоп… Клип… А, чтоб тебе! 
			</p>
			
			<p class="mb-3">
				- Клапаузиусом! Совершенно верно! – быстро поддакнул Трурл, помимо воли насторожившись при этом замечании.
			</p>
			
			<p class="mb-3">
				- Вот именно. 
				И вместо того, чтобы обсудить эту проблему с ним, ты, будучи высокомерным и чванным, а при этом просто неописуемо глупым, 
				ночью находишь хладные останки старого педагога. 
				Скажешь, не так? Ну говори наконец, говори, не мямли!
			</p>
			
			<p class="mb-3">
				- Господин Учитель! Речь идёт о важнейшем деле во всей Вселенной – о счастье всех разумных существ! – выпалил Трурл и, склонившись, 
				как на исповеди перед решёткой микрофона, стал с лихорадочной поспешностью выкладывать со всеми подробностями события, 
				произошедшие после последнего визита Клапаузиуса, ничего не пропуская и не пытаясь даже что-либо скрывать или приукрашивать.
			</p>
			
			<p class="mb-3">
				Цереброн, который сначала молчал как могила, начал по ходу действия вставлять в паузы бесчисленные колкости, издёвки, иронические комментарии, 
				язвительное либо гневное покашливание, - но Трурлу, охваченному могучим порывом, было уже до такой степени всё равно, что он говорил и говорил, 
				пока не описал, наконец, последний свой поступок, и тогда только умолк и, немного запыхавшись, ждал. 
				Цереброн же, который до этого, казалось, никак не мог отхаркаться и откашляться, на удивление, не отзывался ни звуком ни словом целую минуту, 
				а потом звучным, словно бы помолодевшим басом, рёк:
			</p>
			
			<p class="mb-3">
				- Ну да. 
				Ты осёл. 
				А осёл ты потому, что ленивый. 
				Не хотелось ему протирать штаны над общей онтологией! Задал бы я ему жару по философии, да и вообще по аксиологии, 
				как это было моей святой обязанностью, - не припёрся бы он сейчас ночью на кладбище и не ломился бы в мой гроб. 
				Но признаюсь: есть в этом и моя вина! Ты опустился, словно лентяй из лентяев, будучи в известной степени способным типом – 
				а я смотрел на это сквозь пальцы: ведь ты был ловок в низших искусствах, тех, что вытекают из ремесла часовщика. 
				Думал я, что ты с возрастом поумнеешь и повзрослеешь… Да я ведь, медный ты лоб, тысячу, нет - сто тысяч раз говорил на семинарах, что, 
				прежде чем что-то хорошо сделать, нужно подумать. 
				Но ему, конечно, подумать и в голову не пришло! Сосчажива сделал, великий изобретатель, смотрите на него! 
				В 10496 году профессор Неандер описал в «Ежеквартальном обозрении» точь-в-точь такую же машину, а драматург Вырождения, 
				некий Биллион Уыкшпир написал на эту тему произведение искусства, драму в пяти актах; но ты ведь ни научных, ни художественных книг и в руки не берёшь, а?
			</p>
			
			<p class="mb-3">
				Трурл молчал, а разъярённый старец рычал всё громче, так что эхо шло от дальних гробниц:
			</p>
			
			<p class="mb-3">
				- Ты заслуживаешь тюрьмы, и это было бы совсем неплохо! Разве ты не знаешь, что нельзя выключать, или же уничтожать, однажды пробуждённый разум? 
				Значит, шёл прямо ко Всеобщему Счастью, говоришь? А по дороге, в рамках заботливого попечения, одних существ огнём жёг, других топил, как мышей, 
				в пресыщении и излишествах, иных в тюрьмы сажал, пытал, мучал, ноги переламывал, а в конце концов, как я слышал, дошёл и до братоубийства? 
				Да, для Абсолютного Попечителя и Универсального Благодетеля совсем, совсем неплохо! И что же я должен тебе сказать? 
				Хочешь, чтобы я приласкал тебя из гроба? – здесь он неожиданно захихикал, да так, что Трурл весь задрожал. 
				– Значит, говоришь, что меня превзошёл? Сначала, ленивый пёс, ты перепоручил задание машине, которая перепоручила его следующей, и так ad infinitum, 
				а потом самого себя в программу для ЭВМ засунул? Разве ты не знаешь, что нуль, возведённый в любую степень, даёт нуль? 
				Смотрите на него – какой гениальный, размножился, чтобы его было больше, ну и умник же, а? Вот хитрый веник, скажу я вам. 
				Разве ты не знаешь, что Codex Galacticus запрещает самоумножение? Часть XXVV тома 119, раздел X, § 561 и последующие. 
				Экзамены ты сдал благодаря электронным шпаргалкам и дистанционным подсказкам, а теперь не придумал ничего лучшего, 
				чем ворваться ночью на кладбище и ломиться в гробы? Ну, ясное дело. 
				В последний год я читал два раза - повторяю: два раза! – кибернетическую деонтологию (не путать с дентистикой). 
				Нравственность всемогущих! Но ты, как сейчас помню, отсутствовал на лекциях, ибо очень уж тяжко захворал. 
				Разве не так? А ну-ка, отвечай!
			</p>
			
			<p class="mb-3">
				- Собственно … я… был нездоров. 
				– промямлил Трурл. 
			</p>
			
			<p class="mb-3">
				Он уже оправился от первого шока и не особенно корил себя: Цереброн, каким брюзгой был при жизни, таким и остался после смерти; 
				а Трурл всё более утверждался в мысли, что после необходимого ритуала проклятий и брани наступит период положительный: 
				благородный в глубине души своей старец мудрыми советами выведет его из тьмы к свету. 
				Тем временем умный покойник перестал ругать его на чём свет стоит.
			</p>
			
			<p class="mb-3">
				- Значит, так – сказал он. 
				– ошибка твоя в том, что ты не знаешь ни что́ ты хочешь сделать, ни ка́к этого добиться. 
				Это во-первых. 
				Во-вторых: создание Всеобщего Счастья – это детская забава, никому ни на что не нужная. 
				Твой прекрасный Сосчажив является машиной аморальной, т.к. 
				получает наслаждение как от физичесих объектов, так и от мук и страданий других лиц. 
				Чтобы построить счастьетрон, нужно поступать иначе. 
				Вернувшись домой, возьмёшь с полки XXVI том моего Полного собрания сочинений, откроешь его на странице 621 и рассмотришь проект Экстатора, 
				который там находится. 
				Это единственный безупречный вид сознательной установки, которая ни для чего иного не предназначена, как только быть счастливой в 10.000 раз больше, 
				чем Бромео, когда он влез к своей любимой на балкон. 
				В честь Уикшпира я назвал бромеями описанные у него балконные радости и принял за единицу счастливости 1 (один) бромей; 
				но ты, который даже не потрудился просмотреть труды своего учителя, выдумал какие-то кретинские гедоны! 
				Гвоздь в башмаке – это ему лучшее мерило высочайших духовных порывов! Даа… Ну так вот, Экстатор абсолютно счастлив благодаря насыщению, 
				которое является следствием многофазного перемещения в континууме познания, то есть, в нём появляется самонаслаждение с дополнительной обратной связью: 
				чем больше он собою доволен, тем больше он собою доволен, и так до тех пор, пока напряжение не дойдёт до границы опасного; 
				тогда включаются предохранители. 
				А если они не подействуют – знаешь, что будет? Не знаешь, опекун Космоса? Машина, дойдя до ручки, в конце концов лопнет! 
				Да, да, господин неуч! Ведь корпус её… Но не буду я тебе всё это излагать посреди ночи на кладбище, из холодного гроба: сам дома перечитаешь. 
				Наверняка труды мои у тебя или тонут в пыли на самой дальней полке твоей забытой библиотеки или, что мне кажется более вероятным, 
				сложены в сундук и отправлены после моего погребения в подвал. 
				А? Благодаря паре пустяков, которые тебе удалось придумать, ты уже решил, что из тебя вышел самый ловкий пройдоха в Метагалактике, не так ли? 
				Где ты держишь мои Opera Omnia, отвечай быстро!
			</p>
			
			<p class="mb-3">
				- В под… вале… - пробормотал Трурл, и это было гнусной ложью, ибо давно уже он их отвёз в три приёма в городскую библиотеку. 
				Но этого, к счастью, не мог знать труп его учителя, и поэтому, удовлетворённый выказанной проницательностью, тот продолжал уже довольно милостиво:
			</p>
			
			<p class="mb-3">
				- Ну да… Хотя этот счастьетрон и совершенство, но совершенство никому не нужное, потому что сама мысль о том, что туманности, планеты, спутники, 
				звёзды, пульсары и прочие квазары надо бы по очереди попеределать в одни лишь ряды Экстаторов, могла родиться только в мозгах, 
				завязанных в топологический узел Мёбиуса и Клейна, то есть перекрученных во всех измерениях интеллекта. 
				О, моя несчастная судьба! – опять распалился гневом покойник. 
				– Велю наложить замок YALE на калитку и зацементировать кнопку вызова на надгробии! 
				Твой друг Клапаузиус вырвал меня из милых объятий смерти таким звонком в прошлом году, - а может, и в позапрошлом, ведь у меня здесь нет ни часов, 
				ни календаря, как ты можешь догадаться, - и я должен был только потому восстать из мёртвых, 
				что этот мой ученичок не мог сам справиться с метаинформационной антиномией теоремы Аристоидеса. 
				И я, прах из праха, я, мертвец, должен был ему излагать из гроба такие вещи, о которых он даже и не слышал, вещи, 
				которые есть в любом порядочном учебнике континуально-топотропной инфинитезималистики! О Боже, Боже! 
				Как жаль, что Тебя нет, а то бы ты наверняка пожалел сейчас своих киберсынов!
			</p>
			
			<p class="mb-3">
				- Значит, Клапаузиус был здесь… у… у Господина Профессора?! – обрадовался и одновременно изумился Трурл.
			</p>
			
			<p class="mb-3">
				- Конечно. 
				А что, не обмолвился ни словом? Вот она, благодарность робота. 
				Был, был.. 
				А ты этому и радуешься? Ну, скажи-ка, скажи мне сам – оживился труп, - ты́, которого в восторг привела весть о неудаче друга, 
				ты в самом деле хотел весь Космос осчастливить?! 
				И не пришло в твою чугунную башку, что прежде нужно бы оптимализировать собственные этические параметры? 
			</p>
			
			<p class="mb-3">
				- Господин Учитель, а также Профессор! – поспешно воскликнул Трурл, пытаясь отвлечь внимание зловредного старца от своей персоны. 
				- Является ли проблема осчастливливания неразрешимой? 
			</p>
			
			<p class="mb-3">
				- С чего это вдруг? Она только в этом виде неправильно сформулирована. 
				Что такое счастье? Ответ проще пареной репы… Счастье – это прогиб, а значит, 
				расширение метапространства, отделяющего пучок вероятностных коллинеарных отражений от вероятностного объекта, при граничных условиях, 
				установленных омега-корреляцией в альфа-мерном, то есть неметрическом континууме субъединичных соединений, называемых ещё группами моими, 
				то есть Цереброна. 
				Ты, наверное, даже не слышал о субъединичных соединениях, над которыми я работал 48 лет и которые являются производными функционалов, 
				называемых ещё антиноминалами моей Алгебры противоположностей? 
			</p>
			
			<p class="mb-3">
				Трурл был нем, как могила.
			</p>
			
			<p class="mb-3">
				- Когда приходишь на экзамен – сказал умерший с необычной для себя, подозрительной мягкостью, - можно, в конце концов, быть неподготовленным. 
				Но даже не заглянуть в учебник, когда идёшь на могилу профессора – о, это уже такая наглость, - теперь он уже рычал, 
				аж что-то задребезжало в микрофоне, - что если бы я сейчас ожил, меня б на месте кондрашка хватил! – тут он внезапно снова стал ласковым. 
				– А ты,значит, ничего не знаешь, будто бы вчера родился. 
				Ну что же, ладно, мой верный, мой добрый ученик, радость моя загробная! Не слышал о супергруппах, так, видно, 
				придётся мне всё это тебе изложить популярно, упрощённо, как какому-нибудь электрополотёру или другой механической прислуге. 
				Счастье, достойное усилий, не есть целое, но часть чего-то такого, что само не является счастьем и быть им не может. 
				Программа твоя была сплошным кретинизмом, даю тебе в этом слово чести, – а мёртвым костям ты можешь верить. 
				Счастье – не особое измерение, а производное – но этого ты уже не поймёшь,бестолочь. 
				Я тебя насквозь вижу: клянёшься сейчас передо мной, что всё исправишь, что возьмёшься за ум и т.п.; а ведь когда вернёшься домой, 
				и в голову тебе не придёт заглянуть в мои труды! 
			</p>
			
			<p class="mb-3">
				Трурлу оставалось только удивляться сообразительности Цереброна, ибо именно такие искреннейшие намерения он питал. 
			</p>
			
			<p class="mb-3">
				- Нет, ты собираешься попросту взять в руки дубину и разбить вдребезги машину, в которой сначала заключил, а потом и прикончил самого себя! 
				Сделаешь, что захочешь; я не буду тебя стращать и являться к тебе привидением, 
				хотя ничто не помешало бы мне сконструировать перед схождением в могилу соответствующий Призракотрон. 
				Но такая игра в духов, в виде которых я смог бы посещать и держать в узде моих дорогих учеников, показалась мне чем-то недостойным как их, 
				так и себя самого. 
				Неужели я должен и за гробом оставаться вашим стражем, несчастная банда? Кстати, знаешь ли ты о том, что убил себя самого только один раз, 
				то есть в одном лице?
			</p>
			
			<p class="mb-3">
				- Как это «в одном лице»? – не понял Трурл.
			</p>
			
			<p class="mb-3">
				- Голову даю на отсечение, что никакого университета и никаких Трурлов с кафедрами в компьютере не было; ты говорил со своим цифровым отражением, 
				которое, опасаясь – и правилно опасаясь! – что ты выключишь его навеки, как только узнаешь о его неспособности решить задачу, обманывало тебя почём зря.
			</p>
			
			<p class="mb-3">
				- Не может быть! – изумился Трурл.
			</p>
			
			<p class="mb-3">
				- Может быть. 
				Какой мощности была твоя машина?
			</p>
			
			<p class="mb-3">
				- Эпсилон 1010.
			</p>
			
			<p class="mb-3">
				- В машине такого типа нет места для размножения цифритов; ты дал себя провести, в чём я, в конце концов, не вижу ничего плохого, 
				ибо поступок твой был кибернетически постыден. 
				Трурл, время идёт. 
				Ты наполнил мои останки отвращением, от которого избавить может только чёрная сестра Морфея – Смерть, моя последняя возлюбленная. 
				Вернувшись домой, воскресишь кибербрата и расскажешь ему всю правду, то есть опишешь наши кладбищенские беседы; 
				а потом выведешь его из машины на свет божий, материализовав предварительно способом, 
				который найдёшь в «Относительной рекреционалистике» моего педагога, незабвенной памяти пракибернетика Дулайхуса. 
			</p>
			
			<p class="mb-3">
				- Значит, это возможно?
			</p>
			
			<p class="mb-3">
				- Да. 
				Наверняка свет, который отныне будет носить двух Трурлов, окажется перед лицом серьёзной опасности; 
				но не менее гибельным шагом было бы допустить тебя ещё больше погрязнуть в грехе.
			</p>
			
			<p class="mb-3">
				- Но… простите, Господин Учитель, ведь его уже нет… он не существует с той минуты, как я его выключил… и может быть, 
				именно сейчас уже не нужно делать того, что вы приказываете…
			</p>
			
			<p class="mb-3">
				После этих слов раздался дрожащий от негодования крик:
			</p>
			
			<p class="mb-3">
				- Ко всем тяжким атомным ядрам! И я дал этому чудовищу диплом с отличием?!?! О! Как тяжко я наказан за то, что слишком поздно ушёл на тот свет! 
				Видать, уже на твоих экзаменах разум мой значительно ослаб! Как это? 
				Значит, ты считаешь, что если в данный момент твоего двойника нет среди живых, то этим самым не существует также проблема его воскрешения? 
				Ты путаешь физику с этикой так, что хоть за голову хватайся. 
				С точки зрения физики всё равно, живёшь ли ты, или другой Трурл, или вы оба, или же никто; или я резвлюсь на воле, или в гробу лежу, 
				- в физике нет состояний подлых или благородных, добрых или злых, а только то, что есть: оно существует, и всё тут. 
				Но, о глупейший из моих учеников, с точки зрения нематериальных ценностей, то есть этики, дело обстоит иначе! Если бы ты выключил машину, 
				имея в виду лишь, чтобы твой цифровой брат заснул сном как смерть крепким; если бы ты, вынимая штепсель из розетки, 
				питал намерение воткнуть его обратно с утренней зарёй, - проблема братоубийства как совершённого тобою преступления вообще бы не существовала, 
				а я не должен был бы надрывать себе на эту тему глотку в полночь, бесцеремонно поднятый со смертной постели! 
				Ну, пошевели же мозгами, взвесь, чем отличаются с точки зрения физики эти две ситуации: 
				та, в которой выключаешь ты машину с невинными помыслами на одну ночь, и та, в которой ты делаешь то же самое, желая навеки уничтожить цифрового Трурла! 
				Видишь, что физически не отличаются они ничем, ничем, ничем!!! – рычал он, как труба иерихонская, и Трурл осмелился даже подумать, 
				что его достопочтенный учитель набрался в гробу сил, которых ему при жизни недоставало. 
				– Только сейчас я задрожал, заглянув в глубочайшую бездну твоего невежества! Как же так? Значит, по-твоему, тех, кто находится под наркозом, 
				глубоким, как смерть, можно безнаказанно растворять в серной кислоте или стрелять ими из пушки – ведь их сознание не функционирует? 
				Скажи мне: если бы я мог сейчас тебя заковать в оковы Вечного Счастья, то есть засадить в Экстатор, 
				чтобы ты в нём исходил счастьем ближайший двадцать один миллиард лет, и не должен был бы ни осквернять мощи твоего старого учителя, 
				тёмной ночью, как разбойник, крадя информацию из могил, ни ломать себе голову над тем, что ты натворил, и не видел бы ты перед собою дальнейших задач, 
				вопросов, забот, проблем и дилемм, какими вся жизнь усеяна – согласился бы ты на моё предложение? 
				Сменил бы всё теперешнее существование на блеск Вечного Счастья? Отвечай быстро – да или нет?
			</p>
			
			<p class="mb-3">
				- Нет! Ни за что, нет!! – завопил Трурл.
			</p>
			
			<p class="mb-3">
				- Вот видишь, ты, ублюдок разума! И как же ты, сам не желая быть заласканным, унаслаждённым, благообеспеченным и по уши довольным, 
				смеешь предлагать целому Космосу то, от чего сам отворачиваешься и что наполняет тебя ужасом? Трурл! Мёртвые видят ясно! 
				Ты не можешь быть таким законченным негодяем! Нет, ты всего лишь гений со знаком минус – гений кретинизма!
			</p>
			
			<p class="mb-3">
				Послушай, что я тебе скажу. 
				Ничего так не желали наши предки, как бренного бессмертия. 
				Но как только они его открыли и попробовали немножко, так сразу закричали, что им не это было надо! 
				Существо разумное должно всегда видеть перед собой то, что возможно, но ещё более – то, чего не может произойти. 
				Сегодня каждый может жить так долго, как захочет, но вся мудрость и красота нашего существования в том, что ежели кто уже сыт этой жизнью и её трудами, 
				если ему кажется, что уже сделал в ней всё, что было в его силах, то он удаляется на вечный покой; что и я, как и все другие, сделал. 
				Раньше смерть наступала неожиданно, от глупой поломки, прерывая на середине не одну работу, 
				не позволяя докончить многие дела – и в этом заключался древний рок. 
				Но сегодня ценности изменились, и ничего я не жажду больше, чем небытия, которого всякие умственно нечистоплотные типы вроде тебя ежечасно меня лишают, 
				пробираясь в мой гроб и стягивая его с меня, как одеяло.А ты себе решил Космос счастьем напихать, наполнить, набить до отказа, 
				да ещё с четырехкратным превышением! На словах – чтобы обласкать всякую в нём живую тварь, а на деле – потому лишь, что ты лентяй. 
				Хотелось бы тебе выбросить из головы все проблемы, хлопоты, задачи… - но подумай, что бы ты на этом свете делал дальше? Ха-ха! 
				Повесился бы с тоски, или же стал бы выдумывать для этого счастья уничтожающие приспособления. 
				Ergo, из лени ты осчастливить всех захотел, из лени отдал это дело решать машинам, из лени самого себя в машину засадил, 
				и оказался таким образом самым находчивым, самым изобретательным изо всех моих тупых учеников, 
				которых я воспитал в течение 1797 лет моей преподавательской деятельности! 
				Если бы я не сознавал всю бесполезность такого поступка, отвалил бы этот камень и врезал бы тебе по лбу! 
				Ты пришёл на могилу за советом, но я не чудотворец, и не в моих силах отпустить тебе самый малый из множества твоих грехов, 
				- множества, мощность которого приближается к пра-Канторовой альфа-бесконечности! Вернёшься домой, разбудишь кибербрата и сделаешь то, что я тебе сказал.
			</p>
			
			<p class="mb-3">
				- Но, Господин…
			</p>
			
			<p class="mb-3">
				- Заткнись! Когда же всё там закончишь, возьмёшь ведро раствора, лопату, кельму, 
				придёшь на кладбище и как следует замажешь все дырки в облицовке надгробия, через которые течёт в гроб и льётся мне на голову. 
				Всё понял? 
			</p>
			
			<p class="mb-3">
				- Да, Господин Учи…
			</p>
			
			<p class="mb-3">
				- Сделаешь так?
			</p>
			
			<p class="mb-3">
				- Уверяю Вас, что сделаю, Господин Учитель, но я ещё хотел бы знать…
			</p>
			
			<p class="mb-3">
				- А я – сказал могучим, поистине громовым голосом покойник – хотел бы только знать, когда же ты уберёшься прочь! 
				Только посмей ещё раз стукнуть в мою гробницу, я так тебе задвину! Обещаю тебе… Но впрочем, ничего конкретного не обещаю – сам увидишь. 
				Можешь передать от меня привет своему Клапаузиусу и сказать ему то же самое. 
				В последний раз, когда я одарил его поучениями, он так уж спешил, так спешил, что не потрудился даже выразить мне надлежащей благодарности. 
				О, манеры, манеры этих даровитых конструкторов, этих гениев, этих талантов, у которых от спеси уже шарики за ролики зашли!
			</p>
			
			<p class="mb-3">
				- Господин… - начал было Трурл, но в гробнице всё тряслось и шипело, кнопка, которая была втиснута до отказа, выскочила обратно, 
				и глухая тишина распростёрлась надо всем кладбищем; тишина, которую только подчёркивал мягкий шум далёких ветвей.
			</p>
			
			<p class="mb-3">
				Трурл вздохнул, почесал затылок, подумал, усмехнулся, представив себе Клапаузиуса, его поражение и стыд, 
				которые Трурлу представится случай смаковать во время ближайшей встречи, поклонился высокому надгробию, а затем, повернувшись на пятках, 
				весёлый, как пташка и не менее довольный собой, помчался домой, не чуя под собою ног.
			</p>
			
		</div>
		
		`
	)
}

const itemName = {
	rus: 'Как конструктор Трурл решил мир осчастливить'
}

const item = {
	itemlink: getLink(itemName.rus),
	rus: {
		itemName: itemName.rus,
		itemContent: content.rus,
		itemAuthor: 'Станислав Лем',
		itemTranslator: 
		`Перевела с польского<br/>
		${translator.rus}`
		
	}
}

export default item;